import { EnvService } from './../../env.service';
import { SynchButtonComponent } from './../synch-button/synch-button.component';
import { Component, OnInit, AfterContentInit, ElementRef, ViewChild, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { Decorable, Dict, VDict } from 'src/app/types/decorable';
import {
  GridOption,
  AngularGridInstance,
  Column,
  GroupingGetterFunction,
  AngularUtilService,
  AngularComponentOutput,
  MenuCommandItemCallbackArgs,
  SlickGrid,
  DraggableGrouping,
  SlickEvent,
  ColumnPickerExtension
} from 'angular-slickgrid';
declare const Slick: any;


import { ISLMap } from 'src/app/types/@types/sl-map';
import { SLLayer, LayerAccessLevel } from 'src/app/model/sl-layer';
import { LayerSelectionDialogService } from '../dialogs/layer-selection-dialog/layer-selection-dialog.service.';
import { SimpleHandler, IColumnComponent, AttributeRequirement, AttributeInfo, SimpleFunction } from 'src/app/types/@types/sl-v-types';

import { LayerApiService } from 'src/app/model/api-services/layer-api.service';
import { SLMapMemory } from 'src/app/model/sl-map-memory';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';
import { MemoryToolsComponent } from '../memory-tools/memory-tools.component';
import { ActionsFormatter } from 'src/app/model/formatters/actions-formatter';
import { SelectToolsComponent } from '../select-tools/select-tools.component';
import { AccessLevels } from 'src/app/types/access-levels';
import { Synchable, SynchEvent, SynchSelectionsEvent, ISelectionInfo } from 'src/app/model/synchronizer';
import { ResultsService, ResultMoment, ResultsSelectionMode, ResultDisplayState } from 'src/app/services/results.service';
import { ResultHistory } from 'src/app/model/result-history';
import { UUID } from 'angular2-uuid';
import { ColumnFormatter } from 'src/app/model/formatters/columnformatter';
import { AttStorageType, AttributesService } from 'src/app/model/api-services/attributes.service';
import { NoneAggregator } from 'src/app/model/aggregators/none-aggreator';
import { AggregatorSet, AggInfo, AggColumnIds } from 'src/app/model/aggregators/aggregator-set';
import { SlickData } from 'src/app/model/slick-rows/slickdata';
import { ColumnFilter, ColumnFilterInfo } from 'src/app/model/filters/column-filter';
import { CsvExportService } from 'src/app/services/csv-export.service';
import { KmlExportService } from 'src/app/services/kml-export-service';
import { ShpExportService } from 'src/app/services/shp-export-service';
import {
  IDataExportContext, ExportableColumnOption, ExportableColumnOptionDict,
  ExportContentOptionsDict, ExportTypeOptionsDict, ExportTypeOption, ExportContentOption, ExportDataDialogService
} from '../dialogs/export-data-dialog/export-data-dialog-service.';
import { InfoAction } from 'src/app/model/map-actions/info-action';
import { ReportingLevels } from 'src/app/types/reporting_levels';
import { AggName, SLAggregator } from 'src/app/model/aggregators/slaggregator';
import { ZoomToToolsComponent } from '../zoom-to-tools/zoom-to-tools.component';

export interface FeatureInfo {
  feature: any;
  index: number;
  count: number;
  layer: SLLayer;
}

export type AggRef = {
  name: string;
  label: string;
  index: number;
}



@Component({
  selector: 'app-results-view',
  templateUrl: './results-view.component.html',
  styleUrls: ['./results-view.component.scss']
})
export class ResultsViewComponent implements OnInit, AfterContentInit, IDataExportContext {

  private grid1: AngularGridInstance;
  public selections: any = {};
  public set colDefs(defs: Array<Column<any>>) {
    this.columnDefinitions = defs;
  }
  public get colDefs(): Array<Column<any>> {
    return this.columnDefinitions;
  }
  public columnDefinitions: Array<Column<any>> = [];
  private results: SlickData = new SlickData();
  private selectMode: ResultsSelectionMode = 'multi';
  public layers: Array<any> = [];
  public tabSet: Array<any> = [];
  public tabsReady = true;
  public gridReady = true;
  public selectedIndex = 0;
  public selectedFeatureIndex = -1;
  public minSize = true;
  public hasResults = false;
  public hasResultsChange = new EventEmitter<boolean>();
  public hasUnselResults = false;
  public hasUnselResultsChange = new EventEmitter<boolean>();
  public hasSelResults = false;
  public hasSelResultsChange = new EventEmitter<boolean>();
  public isSettingSelections = false;
  public pucSynching = false;
  public infoSynching = false;
  public rawMode = false;
  public selectedGroupingFields: Array<string | GroupingGetterFunction> = ['', '', ''];
  public totalsHeight = 0;
  public customGroupRows = {};
  public aggregatorsVDict: VDict<AggregatorSet> = {};
  public groupValuesVDict: VDict<any> = {};
  public groupedRowsVDict: VDict<boolean> = {};
  public groupedRowSelections: VDict<Array<string>> = {};
  public columnPicker: ColumnPickerExtension = null;
  public handlingResultChange = false;
  // private _slickEventHandler: SlickEventHandler = null;
  public allColumns: Array<Decorable> = [];
  @ViewChild('memoryTools', { static: true }) memoryTools: MemoryToolsComponent;
  @ViewChild('selectTools', { static: true }) selectTools: SelectToolsComponent;
  @ViewChild('zoomToTools', { static: true }) zoomToTools: ZoomToToolsComponent;
  @ViewChild('pucSyncer', { static: true }) pucSyncer: SynchButtonComponent;
  private map: ISLMap;
  private gridObj: any;
  // private dataViewObj: any;
  private height = 0;
  private selectedRows = [];
  private synchProxy: Synchable;
  private moment: ResultMoment;
  private lastSynchEvent: SynchEvent = null;
  public gridOptions: GridOption | any;
  public dataset: Array<any> = [];
  public currentSelections: ISelectionInfo = null;
  public draggableGroupingPlugin: DraggableGrouping;
  public groupTotals: any;
  public aggregators: Array<AggRef> = [];
  public showPostRows = true;
  public showGroupPostRows = true;
  public aggregatorSet: AggregatorSet = new AggregatorSet();
  public showGroupSummaries = true;
  public showGrandSummary = true;
  private anchorColumn = '';
  private filterInfo: any;
  private restoring = false;
  private hadDisplaySettings = false;
  public numberSortFunction;
  public numberSorter = (a, b) => {
    if (!!this.numberSortFunction) {
      return this.numberSortFunction(a, b);
    }
    return a > b;
  }
  public get isSLViewer() {
    return (this.env.GetAppNameFromURL(true) === 'sl-viewer');
  }
  constructor(
    private domNode: ElementRef,
    private layerSelector: LayerSelectionDialogService,
    private angularUtilService: AngularUtilService,
    private layerAPI: LayerApiService,
    private messager: ModalMessagerService,
    private resultsSvc: ResultsService,
    private kmz: KmlExportService,
    private shp: ShpExportService,
    private exporter: ExportDataDialogService,
    private env: EnvService,
    private cdr: ChangeDetectorRef
  ) {

    this.groupedRowsVDict.__grandTotal = true;
    ColumnFilter.SetCompleteHandler((filterInfo: ColumnFilterInfo) => {
      if (filterInfo.filter.destroyed === true) {
        return;
      }
      this.filterInfo = filterInfo;
      this.UpdateColumnHeaders();
      this.UpdateDisplayState();
    });
    this.customGroupRows = {
      getPostRows: (level: number, group, groupInfo) => {
        const rows = [];
        const aggInfo: Array<AggInfo> = this.aggregatorSet.GetAggregatorInfo();
        if (aggInfo.length === 0) {
          return rows;
        }
        if (this.showGroupSummaries === false) {
          return rows;
        }
        if (this.aggregatorSet.GetGroupableCount() === 0) {
          return rows;
        }
        rows.push(new Slick.Custom.Rows.AggGroupTitleRow(
          group,
          groupInfo,
          level
        ));
        if (this.groupedRowsVDict[group.groupingKey] === false) {
          return rows;
        }
        for (const info of aggInfo) {
          if (info.groupable === false) {
            continue;
          }
          rows.push(new Slick.Custom.Rows.AggGroupTotalsRow(
            info.aggName,
            info.aggLabel,
            group,
            groupInfo,
            level
          ));
        }
        return rows;
      },
      showPostRows: this.showGroupPostRows
    }
    this.lastSynchEvent = this.lastSynchEvent;
    const me = this;
    this.synchProxy = {
      synchId: 'results-list',
      channel: ResultHistory.LATEST_TABULAR_ID,
      handler: (event: SynchEvent) => {
        me.HandleSynchEvent(event);
      },
      synchables: ['results-gallery-list', 'popup-control', 'layer-gallery']
    }

    this.gridOptions = {
      rowHeight: Number(getComputedStyle(document.documentElement).getPropertyValue('--rem')) * 1.8,
      datasetIdPropertyName: 'gid',
      groupOptions: {
        isGroupRowSelectable: false,
        isGroupTotalsRowSelectable: false,

      },

      // datasetIdPropertyName: 'gid',
      autoHeight: false,
      enableDraggableGrouping: true,
      enableGrouping: true,
      createUnfreezablePreHeaderPanel: true,
      createPreHeaderPanel: true,
      showPreHeaderPanel: false,
      preHeaderPanelHeight: 0,
      showFooterRow: false,
      /*autoResize: {
        calculateAvailableSizeBy: 'container',
        delay: 0,
        containerId: 'resultsGrid',

      },*/
      forceFitColumns: false,
      autoFitColumnsOnFirstLoad: true,
      enableAutoSizeColumns: false,
      fullWidthRows: false,
      enableCheckboxSelector: true,
      enableColumnPicker: true,
      columnPicker: {
        hideForceFitButton: true,
        hideSyncResizeButton: false,
        onExtensionRegistered(columnPicker) {
          this.columnPicker = columnPicker
          this._slickEventHandler = new Slick.EventHandler();
          /*this._slickEventHandler.subscribe(columnPicker.onColumnsChanged, (e: any, args: any) => {
            console.log('columns changed', e, args);
          });*/
        },

      },
      dataView: {
        syncGridSelection: false,
        syncGridSelectionWithBackendService: false,

        customItemMetadataProvider: (item) => {
          const level = !!item.level ? item.level : 0;
          switch (item.__custom) {
            case 'grand-totals-title-row':
              return new Slick.Custom.Data.ItemMetadata({
                rowCssClass: 'grand-totals-title-row',
                columns: {
                  0: {
                    colspan: '*',
                    cellCssClass: 'grand-totals-title-cell',
                    formatter: (row: number, cell: number, cellValue: any, columnDef: Column<any>, cellItem: any, grid?: SlickGrid) => {
                      const count = me.layers[me.selectedIndex].count;
                      const expanded = (this.groupedRowsVDict.__grandTotal === true);
                      const expandedClass = (expanded === true) ? ' expanded ' : '';
                      let groupCount = 0;
                      for (const key in this.groupedRowsVDict) {
                        if (this.groupedRowsVDict.hasOwnProperty(key)) {
                          if (key.substr(0, 1) === '_') {
                            continue;
                          }
                          if (typeof this.groupedRowsVDict[key] === 'boolean') {
                            groupCount += 1;
                          }
                        }
                      }
                      let caret = (expanded === true) ? 'caret-down' : 'caret-right';
                      caret += expandedClass;
                      if (!!grid) {
                        return `<div class="agg-indent-spacer" style="width:fit-content"></span><span class="fas fa-calculator mr-1" data-click-target="grand-totals"></span><span class="fas fa-${caret} mr-1" data-click-target="grand-totals"></span></div>Grand Summary for ${count} results in ${groupCount} groups`;
                      } else {
                        return ''.padStart((cellItem.level + 1) * 4, ' ') + 'Grand Summary for all results ';
                      }
                    },
                    xlsFormatter: (row: any) => {
                      const count = me.layers[me.selectedIndex].count;
                      let groupCount = 0;
                      for (const key in this.groupedRowsVDict) {
                        if (this.groupedRowsVDict.hasOwnProperty(key)) {
                          if (key.substr(0, 1) === '_') {
                            continue;
                          }
                          if (typeof this.groupedRowsVDict[key] === 'boolean') {
                            groupCount += 1;
                          }
                        }
                      }
                      const groupingInfo = this.HasGroupings() ? ` in ${groupCount} groups` : '';
                      return ''.padStart((row.level + 1) * 4, ' ') + `Grand Summary for ${count} results${groupingInfo}`;

                    }
                  }
                },
              });
            // break;
            case 'agg-group-title-row':
              return new Slick.Custom.Data.ItemMetadata({
                rowCssClass: 'slick-row agg-group-row grouped-cell group-level-' + level + ' agg-title-row',
                formatter: (..._args: any[]) => {
                  return '';
                },
                columns: {
                  0: {
                    colspan: '*',
                    cellCssClass: 'agg-title-cell',
                    formatter: (row: number, cell: number, _cellValue: any, _columnDef: Column<any>, cellItem: any, grid?: SlickGrid) => {
                      const vals = cellItem.group.groupingKey.split(':|:');
                      let groupTitle = '';
                      const groupings = this.grid1.dataView.getGrouping();

                      let i = -1;
                      for (const val of vals) {
                        i++;
                        if (i > 0) {

                          groupTitle += `<span class="group-title-divider"></span>`;
                        }
                        if (groupings.length > i) {
                          const groupCol = this.GetColumnByName(groupings[i].getter);
                          const formattedVal = ColumnFormatter.Format(row, cell, val, groupCol, this.grid1.dataView, this.grid1);
                          groupTitle += `${groupCol.name} = ${formattedVal}`;
                        }
                        // (colGroup as Slick.Group<Slick.SlickData>).get
                      }
                      if (!!grid) {
                        if (!this.groupedRowsVDict.hasOwnProperty(cellItem.group.groupingKey)) {
                          this.groupedRowsVDict[cellItem.group.groupingKey] = true;
                        }
                        const expanded = this.groupedRowsVDict[cellItem.group.groupingKey] === true;
                        const expandedClass = expanded === true ? ' expanded ' : '';
                        let caret = expanded === true ? 'caret-down' : 'caret-right';
                        caret += expandedClass;
                        return `<div class="agg-indent-spacer" data-groupingkey="${cellItem.group.groupingKey}" style = "width:calc(1.5em + (${(cellItem.level + 1)} * 1em));"><span data-click-target="group:${cellItem.group.groupingKey}" class="fas fa-calculator mr-1"></span><span data-click-target="group:${cellItem.group.groupingKey}" class="fas fa-${caret} mr-1" ></span></div>Summary for group ${groupTitle}`;
                      } else {

                        return ''.padStart((cellItem.level + 1) * 4, ' ') + 'Summary for group ' + groupTitle; // cellItem.group.groupingKey;
                      }
                    },
                    xlsFormatter: (row: any, attMap: any) => {
                      const vals = row.group.groupingKey.split(':|:');
                      let groupTitle = '';
                      const groupings = this.grid1.dataView.getGrouping();
                      let i = -1;
                      for (const val of vals) {
                        i++;
                        if (i > 0) {

                          groupTitle += ` / `;
                        }
                        if (groupings.length > i) {
                          const groupCol = this.GetColumnByName(groupings[i].getter);
                          const getter = groupings[i].getter;
                          const attVal = {}
                          attVal[getter] = val;
                          const formattedVal = ColumnFormatter.FormatText(attVal, attMap[groupings[i].getter]);
                          groupTitle += `${groupCol.name} = ${formattedVal}`;
                        }
                        // (colGroup as Slick.Group<Slick.SlickData>).get
                      }
                      return ''.padStart((row.level + 1) * 4, ' ') + 'Summary for group ' + groupTitle;
                    }
                  }
                },
                editor: null
              });
              break;
            case 'agg-group-totals-row':
              return new Slick.Custom.Data.ItemMetadata({
                cellCssClass: 'slick-cell agg-cell',
                rowCssClass: 'slick-row agg-group-row grouped-cell group-level-' + level,
                cellFormatter: (row: number, cell: number, cellValue: any, columnDef: Column<any>, cellItem: any, grid?: SlickGrid) => {
                  if (columnDef.id === '_sl_actions') {
                    return cellItem.aggLabel;
                  }
                  if (!cellItem.group || !cellItem.group.groupingKey) {
                    return '';
                  }
                  if (!this.aggregatorsVDict[cellItem.group.groupingKey]) {
                    return '';
                  }
                  if (!this.groupValuesVDict[cellItem.group.groupingKey]) {
                    return '';
                  }
                  const aggregatorSet: AggregatorSet = this.aggregatorsVDict[cellItem.group.groupingKey];
                  const aggName = cellItem.aggName;
                  const totals = this.groupValuesVDict[cellItem.group.groupingKey];
                  if (!totals || !totals[aggName]) {
                    return '';
                  } else if (totals[aggName][columnDef.id]) {
                    if ([null, undefined, NaN].indexOf(totals[aggName][columnDef.id]) > -1) {
                      return '';
                    }
                  }
                  const value = totals[aggName][columnDef.id];
                  switch (aggName) {
                    case 'count':
                      const val = Number(value);
                      if (isNaN(val)) {
                        return '';
                      }
                      return val;
                  }
                  return ColumnFormatter.Format(row, cell, value, columnDef, cellItem, grid);

                }, xlsFormatter: (row: any, attribute: AttributeInfo, rawMode) => {
                  if (attribute.name === 'gid') {
                    return ''.padStart((row.level + 1) * 4, ' ') + row.aggLabel;
                  }
                  if (!row.group || !row.group.groupingKey) {
                    return '';
                  }
                  if (!this.aggregatorsVDict[row.group.groupingKey]) {
                    return '';
                  }
                  if ([undefined, null, NaN].indexOf(this.groupValuesVDict[row.group.groupingKey]) > -1) {
                    return '';
                  }
                  const aggName = row.aggName;
                  const totals = this.groupValuesVDict[row.group.groupingKey];
                  const value = totals[aggName][attribute.name];
                  const attVal = {};
                  switch (aggName) {
                    case 'count':
                      const val = Number(value);
                      if (isNaN(val)) {
                        return '';
                      }
                      return val;
                  }
                  attVal[attribute.name] = value;
                  if (rawMode === true) {
                    return value;
                  }
                  const result = ColumnFormatter.FormatText(attVal, attribute);

                  return (result === undefined) ? '' : ''.padStart((row.level + 1) * 4, ' ') + result;
                }
              });
              break;
            case 'agg-totals-row':
              return new Slick.Custom.Data.ItemMetadata({
                cellCssClass: 'agg-cell',
                rowCssClass: 'agg-totals-row',
                cellFormatter: (row: number, cell: number, cellValue: any, columnDef: Column<any>, cellItem: any, grid?: SlickGrid) => {
                  const name = cellItem.aggName;

                  if (columnDef.id === '_sl_actions') {
                    return cellItem.aggLabel;
                  }

                  if (!this.groupValuesVDict || !this.groupValuesVDict.__grandTotal) {
                    return '';
                  }
                  const totals = this.groupValuesVDict.__grandTotal;


                  if (!totals || !totals[name] || ([null, undefined, NaN].indexOf(totals[name][columnDef.id]) > -1)) {
                    return '';
                  }
                  switch (name) {
                    case 'count':
                      const val = Number(totals[name][columnDef.id]);
                      if (isNaN(val)) {
                        return '';
                      }
                      return Number(val);
                  }
                  const value = totals[name][columnDef.id];
                  return ColumnFormatter.Format(row, cell, totals[name][columnDef.id], columnDef, cellItem, grid);
                },
                xlsFormatter: (row: any, attribute: AttributeInfo, rawMode: boolean = false) => {
                  const name = row.aggName;

                  if (attribute.name === 'gid') {
                    return row.aggLabel;
                  }

                  if (!this.groupValuesVDict || !this.groupValuesVDict.__grandTotal) {
                    return '';
                  }
                  const totals = this.groupValuesVDict.__grandTotal;


                  if (!totals || !totals[name] || ([null, undefined, NaN].indexOf(totals[name][attribute.name]) > -1)) {
                    return '';
                  }
                  switch (name) {
                    case 'count':
                      const val = Number(totals[name][attribute.name]);
                      if (isNaN(val)) {
                        return '';
                      }
                      return Number(val);
                  }


                  const value = totals[name];
                  if (rawMode === true) {
                    return value[attribute.name];
                  }
                  return ColumnFormatter.FormatText(value, attribute);
                  // return ColumnFormatter.Format(row, cell, totals[name][columnDef.id], columnDef, cellItem, grid);
                }
              });
          };
        },
        customRows: {
          getPostRows: () => {
            const postRows = [];
            const aggInfo: Array<AggInfo> = this.aggregatorSet.GetAggregatorInfo();
            if (aggInfo.length === 0) {
              return postRows;
            }
            if (this.showGrandSummary === false) {
              return postRows;
            }
            postRows.push(
              new Slick.Custom.Rows.GrandTotalsTitleRow()
            );
            if (this.groupedRowsVDict.__grandTotal === false) {
              return postRows;
            }
            for (const info of aggInfo) {
              postRows.push(
                new Slick.Custom.Rows.AggTotalsRow(
                  info, this.groupTotals
                )
              );
            }
            return postRows;
          },
          showPostRows: this.showPostRows
        }

      },
      enableAutoResize: false,       // true by default
      enableCellNavigation: true,
      enableRowSelection: true,
      enableFiltering: true,
      enableFilterTrimWhiteSpace: true,
      createFooterRow: false,
      defaultColumnSortFieldId: 'id',
      showHeaderRow: false,
      enableHeaderMenu: true,
      headerMenu: {
        onBeforeMenuShow: (_e: Event, args: any) => {
          const anchorIndex = (this.anchorColumn === '') ? -1 : this.GetColumnIndex(this.anchorColumn);
          const columnIndex = this.GetColumnIndex(args.column.id);

          if ((args.menu.items.length > 0) && !!args.menu.items[0].title && args.menu.items[0].title !== 'Column Options') {

            args.menu.items.unshift({
              iconCssClass: 'hidden',
              title: 'Column Options',
              command: 'close-menu',
              positionOrder: 0
            });
          }
          let lastPositionOrder = 1;
          let commandFound = false;
          for (const argItem of args.menu.items) {
            argItem.positionOrder = lastPositionOrder;
            lastPositionOrder += 1;
            if (argItem.command === 'reset-width') {
              commandFound = true;
            }
            switch (argItem.command) {
              case 'column-resize-by-content':
                argItem.cssClass = 'hidden';
                continue;
                break;
              case 'reset-width':

                break;
              case 'anchor-set':
                argItem.cssClass = (anchorIndex !== columnIndex) ? '' : 'hidden';
                break;
              // tslint:disable-next-line: no-switch-case-fall-through
              case 'move-front':
                argItem.cssClass = (columnIndex >= this.GetColumnStartOffset()) ? '' : 'hidden';
                break;
              case 'anchor-front':
                argItem.cssClass = (anchorIndex >= columnIndex) ? 'hidden' : '';
                break;
              case 'anchor-remove':
                argItem.cssClass = (anchorIndex >= columnIndex) ? '' : 'hidden';
                break;
              case 'anchor-remove-from':
                argItem.cssClass = (anchorIndex >= columnIndex) ? '' : 'hidden';
                break;

            }
            if (!!argItem.title && argItem.title === 'Summary Settings') {
              break;
            }

          }


          if (args.column.id === '_sl_actions') {

            /*
            args.menu.items = [
              {
                title: 'Summary Settings',
                command: '',
                positionOrder: 0
              }, {
                divider: true,
                command: '',
                positionOrder: 1
              }, {
                title: `< input type = "checkbox" > </input>Show/Hide Record Count`,
                command: 'toggle-count',
                positionOrder: 1
              }
            ]
            */
            return;
          }
          if (commandFound === false) {
            let ignoreNext = false;
            for (const item of args.menu.items) {
              if (ignoreNext) {
                ignoreNext = false;
                if (item.divider === true) item.divider = false;
                item.cssClass = 'hidden';
                continue;
              }
              if (item.command === 'clear-filter') {
                item.title = 'Clear Filter';
              }
              if (!!item.positionOrder) {
                lastPositionOrder = item.positionOrder;
              }
              if (lastPositionOrder < 7) {
                if (lastPositionOrder > 1) {
                  if (item.divider = true) {
                    item.divider = false;
                  }
                  item.cssClass = 'hidden';
                  continue;
                }
              }
              switch (item.command) {

                case 'reset-width':

                  break;
                case 'anchor-set':
                  item.cssClass = (anchorIndex !== columnIndex) ? '' : 'hidden';
                  break;
                // tslint:disable-next-line: no-switch-case-fall-through
                case 'move-front':
                  item.cssClass = (columnIndex >= this.GetColumnStartOffset()) ? '' : 'hidden';
                  break;
                case 'anchor-front':
                  item.cssClass = (anchorIndex >= columnIndex) ? 'hidden' : '';
                  break;
                case 'anchor-remove':
                  item.cssClass = (anchorIndex >= columnIndex) ? '' : 'hidden';
                  break;
                case 'anchor-remove-from':
                  item.cssClass = (anchorIndex >= columnIndex) ? '' : 'hidden';
                  break;

              }


              if (item.command.indexOf('toggle-') === 0) {
                item.iconCssClass = 'empty-square' +
                  (this.aggregatorSet.HasAggColumn(item.command.split('-').pop() as AggName, args.column) ?
                    ' checked' : '');
              }


            }


            args.menu.items.push(
              {
                divider: true,
                command: '',
                positionOrder: lastPositionOrder
              }
            );
            lastPositionOrder += 1;
            args.menu.items.push(
              {
                iconCssClass: 'fas fa-anchor',
                title: 'Anchor Columns',
                command: 'anchor-set',
                cssClass: (anchorIndex !== columnIndex) ? '' : 'hidden',
                positionOrder: lastPositionOrder
              }
            );
            lastPositionOrder += 1;
            args.menu.items.push(
              {
                iconCssClass: 'fas fa-anchor danger',
                title: 'Clear Anchoring',
                command: 'anchor-remove',
                cssClass: (anchorIndex >= columnIndex) ? '' : 'hidden',
                positionOrder: lastPositionOrder
              }
            )


            lastPositionOrder += 1;
            args.menu.items.push({
              iconCssClass: 'policon fas fa-anchor danger',
              title: 'Remove From Anchored',
              command: 'anchor-remove-from',
              cssClass: (anchorIndex >= columnIndex) ? '' : 'hidden',
              positionOrder: lastPositionOrder
            });

            lastPositionOrder += 1;
            args.menu.items.push({
              iconCssClass: 'policon fas step-backward-anchor',
              title: 'Anchor to front',
              command: 'anchor-front',
              cssClass: (anchorIndex >= columnIndex) ? 'hidden' : '',
              positionOrder: lastPositionOrder
            });

            lastPositionOrder += 1;
            args.menu.items.push({
              iconCssClass: 'fas fa-step-backward',
              title: 'Move to front',
              command: 'move-front',
              cssClass: (columnIndex >= this.GetColumnStartOffset()) ? '' : 'hidden',
              positionOrder: lastPositionOrder
            });

            lastPositionOrder += 1;
            args.menu.items.push({
              iconCssClass: 'fas fa-text-width',
              title: 'Fit Width',
              command: 'fit-width',
              positionOrder: lastPositionOrder
            });
            lastPositionOrder += 1;
            args.menu.items.push({
              iconCssClass: 'fas fa-text-width',
              title: 'Reset Width',
              command: 'reset-width',
              positionOrder: lastPositionOrder
            }
            );
            lastPositionOrder += 1;
            args.menu.items.push({
              divider: true,
              positionOrder: lastPositionOrder
            }
            );
            lastPositionOrder += 1;
            args.menu.items.push({
              divider: false,
              title: 'Reporting',
              iconCssClass: 'hidden',
              positionOrder: lastPositionOrder
            }
            );

            args.menu.items.push(
              {
                iconCssClass: 'fas fa-magic',
                title: 'Edit Report Casting',
                command: 'attribute-edit-casting',
                positionOrder: lastPositionOrder
              }
            );
            lastPositionOrder += 1;
            args.menu.items.push(
              {
                iconCssClass: 'empty-square' +
                  (this.HasGroup(args.column.id) ? ' checked' : ''),
                title: `Group Data`,
                command: 'toggle-group',
                positionOrder: lastPositionOrder

              }
            );
            lastPositionOrder += 1;


            lastPositionOrder += 1;
            args.menu.items.push(
              {
                iconCssClass: 'hidden',
                textCssClass: 'menu-entry-title',
                title: 'Summary Settings',
                command: '',
                positionOrder: lastPositionOrder
              }
            );
          }
          if (commandFound === true) {
            args.menu.items = args.menu.items.slice(0, lastPositionOrder - 1);

          }

          lastPositionOrder += 1;
          if (AttributesService.EffectiveTypeSupportsStat(args.column.params.attribute, 'avg') === true) {
            args.menu.items.push(
              {
                iconCssClass: 'empty-square' +
                  (this.aggregatorSet.HasAggColumn('avg', args.column) ? ' checked' : ''),
                title: `Average`,
                command: 'toggle-avg',
                positionOrder: lastPositionOrder

              }
            );
            lastPositionOrder += 1;
          }
          if (AttributesService.EffectiveTypeSupportsStat(args.column.params.attribute, 'count') === true) {
            args.menu.items.push(
              {
                iconCssClass: 'empty-square' +
                  (this.aggregatorSet.HasAggColumn('count', args.column) ? ' checked' : ''),
                title: `Count`,
                command: 'toggle-count',
                positionOrder: lastPositionOrder

              }
            );
            lastPositionOrder += 1;
          }
          if (AttributesService.EffectiveTypeSupportsStat(args.column.params.attribute, 'first') === true) {
            args.menu.items.push(
              {
                iconCssClass: 'empty-square' +
                  (this.aggregatorSet.HasAggColumn('first', args.column) ? ' checked' : ''),
                title: `First`,
                command: 'toggle-first',
                positionOrder: lastPositionOrder

              }
            );
            lastPositionOrder += 1;
          }
          if (AttributesService.EffectiveTypeSupportsStat(args.column.params.attribute, 'last') === true) {
            args.menu.items.push(
              {
                iconCssClass: 'empty-square' +
                  (this.aggregatorSet.HasAggColumn('last', args.column) ? ' checked ' : ''),
                title: `Last`,
                command: 'toggle-last',
                positionOrder: lastPositionOrder

              }
            );
            lastPositionOrder += 1;
          }
          if (AttributesService.EffectiveTypeSupportsStat(args.column.params.attribute, 'max') === true) {
            args.menu.items.push(
              {
                iconCssClass: 'empty-square' +
                  (this.aggregatorSet.HasAggColumn('max', args.column) ? ' checked ' : ''),
                title: `Max`,
                command: 'toggle-max',
                positionOrder: lastPositionOrder

              }
            );
            lastPositionOrder += 1;
          }
          if (AttributesService.EffectiveTypeSupportsStat(args.column.params.attribute, 'median') === true) {
            args.menu.items.push(
              {
                iconCssClass: 'empty-square' +
                  (this.aggregatorSet.HasAggColumn('median', args.column) ? ' checked ' : ''),
                title: `Median`,
                command: 'toggle-median',
                positionOrder: lastPositionOrder

              }
            );
            lastPositionOrder += 1;
          }
          if (AttributesService.EffectiveTypeSupportsStat(args.column.params.attribute, 'min') === true) {
            args.menu.items.push(
              {
                iconCssClass: 'empty-square' +
                  (this.aggregatorSet.HasAggColumn('min', args.column) ? ' checked ' : ''),
                title: `Min`,
                command: 'toggle-min',
                positionOrder: lastPositionOrder

              }
            );
            lastPositionOrder += 1;
          }
          if (AttributesService.EffectiveTypeSupportsStat(args.column.params.attribute, 'min') === true) {
            args.menu.items.push(
              {
                iconCssClass: 'empty-square' +
                  (this.aggregatorSet.HasAggColumn('sum', args.column) ? ' checked ' : ''),
                title: `Sum`,
                command: 'toggle-sum',
                positionOrder: lastPositionOrder

              }
            );
            lastPositionOrder += 1;
          }
          if (AttributesService.EffectiveTypeSupportsStat(args.column.params.attribute, 'stddev') === true) {
            args.menu.items.push(
              {
                iconCssClass: 'empty-square' +
                  (this.aggregatorSet.HasAggColumn('stddev', args.column) ? ' checked' : ''),
                title: `Standarad Devation`,
                command: 'toggle-stddev',
                positionOrder: lastPositionOrder

              }
            );
          }

        },
        onCommand: (e: Event, args: MenuCommandItemCallbackArgs) => {
          // e.preventDefault();
          // e.stopImmediatePropagation();
          let isOn = false;
          let closeAfter = false;
          // const header = args.grid.getHeaderColumn(args.column.id);
          let gridColumns: Array<Column<any>>;
          switch (args.command) {
            case 'hide':
              ColumnFilter.SetColumns(this.gridObj.getColumns());
              ColumnFilter.currentInstance.Update();
              break;
            case 'anchor-set':
              this.AnchorAtColumn(args.column.id);
              ColumnFilter.currentInstance.Update();
              // this.gridObj.setColumns(ColumnFilter.GetColumns());

              break;
            case 'anchor-remove':
              this.anchorColumn = '';
              args.grid.setOptions({ frozenColumn: -1 });
              ColumnFilter.currentInstance.Update();
              // this.gridObj.setColumns(ColumnFilter.GetColumns());
              this.UpdateDisplayState();

              break;
            case 'anchor-remove-from':
              this.RemoveFromAnchored(args.column.id);
              break;
            case 'move-front':
              if (this.GetColumnIndex(args.column.id) >= this.GetColumnStartOffset()) {
                this.MoveColumnToFront(args.column.id);
              }
              break;
            case 'anchor-front':
              if (this.GetColumnIndex(args.column.id) >= this.GetColumnStartOffset()) {
                this.AnchorToFront(args.column.id);
              }
              break;
            case 'fit-width':
              gridColumns = this.gridObj.getColumns();
              for (const col of gridColumns) {
                if (col.id === args.column.id) {
                  col.width = this.FitColumnWidth(col);
                  break;
                }
              }
              this.gridObj.setColumns(gridColumns);
              break;
            case 'reset-width':
              gridColumns = this.gridObj.getColumns();
              for (const col of gridColumns) {
                if (col.id === args.column.id) {
                  col.width = 100;
                  break;
                }
              }

              this.gridObj.setColumns(gridColumns);
              break;
            case 'close-menu':
              /*if ($(e.target).hasClass('slick-header-menucontent')) {
                $(e.target).parent().parent().remove();
              } else {
                $(e.target).parent().remove();
              }
              */
              $(e.target).parents('.slick-header-menu').remove();

              return;
            case 'attribute-edit-casting':
              const column = args.column;
              if (this.hasResults === true) {
                const layer = this.GetSLLayer();
                InfoAction.EditAttributeCasting(this.map.component, { layer: (layer), attribute: column.id, mode: 'display' });
              }
              return;
            case 'toggle-group':
              const groupings = this.grid1.dataView.getGrouping();

              if (!this.HasGroup(args.column.id)) {
                (this.draggableGroupingPlugin as any).addGroup(args.column);
                // this.draggableGroupingPlugin.setDroppedGroups(this.grid1.dataView.getGrouping());
              } else {
                (this.draggableGroupingPlugin as any).removeGroup(args.column.id);

              }
              args.item.iconCssClass = 'empty-square' + (this.HasGroup(args.column.id) ? ' checked' : '');
              return;

          }

          if (args.command.indexOf('toggle-') > -1) {
            const featuresBefore = this.currentSelections.features;
            isOn = this.ToggleAggregator(args.column, args.command.split('-').pop() as AggName);
            const newRows = [];
            for (const feature of featuresBefore) {
              const row = this.grid1.dataView.getRowById(feature);
              newRows.push(row);
            }
            this.gridObj.setSelectedRows(newRows);
            /* const cols = this.gridObj.getColumns();
            let i = -1;
            for (const col of cols) {
              i++;
              if (col.id === args.column.id) {
                break;
              }
            }
            if (i > -1) {
              cols.splice(2, 0, args.column);
              if (i > 2) {
                cols.splice(i + 1, 1);
              }
            }
            this.grid1.slickGrid.setColumns(cols)
            */

          } else {
            closeAfter = true;
          }
          const itemElement = $('.slick-header-menuicon', $(e.currentTarget));
          itemElement.toggleClass('checked', isOn === true);
          const colHeaderElement = $('.sl-col-' + args.column.id);
          if (!!colHeaderElement) {
            $('.slick-header-menubutton', colHeaderElement).toggleClass(
              'summarized', this.aggregatorSet.ColumnHasAggs(args.column)
            );
          }
          /* if (args.item && !((args.item as any).onClick)) {
            (args.item as any).onClick = (e2) => {
              // this.gridOptions.headerMenu.onCommand(e, args);
              if (closeAfter === true) {
                e2.preventDefault();
                e2.stopImmediatePropagation();
              }
            }
            itemElement.on('click', (args.item as any).onClick);
          }*/
          if (closeAfter === true) {
            $(e.target).parents('.slick-header-menu').remove();

          }


        }/*,
				onColumnsChanged(event: SlickEvent, args: any) {
					console.log('Header Menu, column changed', event, args);
				}*/
      },
      gridMenu: {
        hideExportExcelCommand: true,
        hideForceFitButton: true,
        onColumnsChanged: (event: SlickEvent, args: any) => {
          ColumnFilter.SetColumns(args.columns);
        },
        customItems: [
          {

            iconCssClass: 'fas fa-text-width',
            title: 'Reset Column Widths',
            disabled: false,
            command: 'reset-widths'
          }, {
            iconCssClass: 'fas fa-database',
            title: 'Show Raw Data',
            command: 'set-raw-mode'
          }, {
            iconCssClass: 'fas fa-magic',
            title: 'Show Cast Data',
            command: 'unset-raw-mode'
          }, {
            iconCssClass: 'fas fa-minus',
            title: 'Toggle Grouping Row',
            command: 'toggle-grouping-row'

          }, {
            iconCssClass: `fas fa-calculator`,
            title: 'Toggle Group Summaries',
            command: 'toggle-group-summaries'
          }, {
            iconCssClass: 'fas fa-calculator',
            title: 'Toggle Grand Summary',
            command: 'toggle-grand-summary'
          }, {
            iconCssClass: 'export-data fa fa-save',
            title: 'Export Data',
            disabled: false,
            command: 'export-data'
          }/*, {
						iconCssClass: 'fas fa-list rot-90r',
						title: 'Toggle All Columns On/Off',
						command: 'toggle-all-columns'
					}
					*/
          /*, {
            iconCssClass: 'export-memory fa fa-save',
            title: 'Export remembered',
            disabled: false,
            command: 'export-memory'
          }, {
            iconCssClass: 'export-unselected fa fa-save',
            title: 'Export unselected results',
            disabled: false,
            command: 'export-unselected'
          }, {
            iconCssClass: 'export-selected fa fa-save',
            title: 'Export selected results',
            disabled: false,
            command: 'export-selected'
          }, {
            iconCssClass: 'export-all fa fa-save',
            title: 'Export all results',
            disabled: false,
            command: 'export-all'
          }, {
            iconCssClass: 'export-excel fas fa-file-excel',
            title: 'Export to Excel',
            disabled: false,
            command: 'sl-export-excel'
          }, {
            iconCssClass: 'export-shp fas fa-file-archive',
            title: 'Export to ESRI ShapeFile .shp',
            disabled: false,
            command: 'sl-export-shp'
          }, {
            iconCssClass: 'export-kmz far fa-file-archive',
            title: 'Export to GoogleEarth .kmz',
            disabled: false,
            command: 'sl-export-kmz'
          }*/
        ],
        onCommand: (e: any, args: any) => {

          // let gids: Array<string>;
          // const layerId = this.results[this.selectedIndex].layer;
          // const layer: SLLayer = this.map.GetLayerById(layerId);

          switch (args.command) {
            case 'export-data':
              if (args.disabled === true) {
                this.messager.Notify('This layer is not available for export');
              }
              this.exporter.Show(() => { }, this.map, {
                context: this
              })
              break;
            /*
            case 'sl-export-excel':
              {
                const exportData = this.grid1.dataView.getRows();
                ExcelIoService.ExportData(this.messager, exportData, this.GetCurrentColumnIds()
                  , this.currentSelections.layer, this.moment, this.rawMode, true);
                XLSExportService.ExportData(this.messager, this.GetCurrentColumnIds(), this.currentSelections.layer,
                this.gridOptions.dataView.customItemMetadataProvider, exportData, this.rawMode);
              }
              break;
            case 'sl-export-shp':
              {
                const exportData = this.grid1.dataView.getRows();
                this.shp.ExportSHP(this.messager, this.currentSelections.layer.name + '_results.kmz',
                  this.currentSelections.layer,
                  this.GetCurrentColumnIds(),
                  exportData, this.rawMode);
              }
              break;
            case 'sl-export-kmz':
              {
                const exportData = this.grid1.dataView.getRows();
                this.kmz.ExportKMZ(this.messager, this.currentSelections.layer.name + '_results.kmz',
                  this.currentSelections.layer,
                  this.GetCurrentColumnIds(),
                  exportData, this.rawMode);
              }
              break;

                      */
            case 'export-all':
              {
                const exportData = this.GetRecords('all');
                CsvExportService.ExportData(this.messager, this.columnDefinitions, this.currentSelections.layer, exportData, this.rawMode);
              }
              return;
            /*gids = this.GetGIDs('all');
            this.layerAPI.CSVExport(
              this.map.project.id,
              layer,
              gids,
              'all'
            );*/
            // break;
            case 'export-selected':
              {
                const exportData = this.GetRecords('selected');
                CsvExportService.ExportData(this.messager, this.columnDefinitions, this.currentSelections.layer, exportData, this.rawMode);
              }
              /*
              gids = this.GetGIDs('selected');
              this.layerAPI.CSVExport(
                this.map.project.id,
                layer,
                gids,
                'selected'
              );*/
              break;
            case 'export-unselected':
              {
                const exportData = this.GetRecords('unselected');
                CsvExportService.ExportData(this.messager, this.columnDefinitions, this.currentSelections.layer, exportData, this.rawMode);
              }
              /*gids = this.GetGIDs('unselected');
              this.layerAPI.CSVExport(
                this.map.project.id,
                layer,
                gids,
                'unselected'
              );
              */
              break;
            case 'export-memory':
              {
                this.messager.Progress('Retrieving records for remembered features', false, null, 'Retrieving data');
                this.layerAPI.SearchFeatures(
                  {
                    idField: 'gid',
                    layer: this.map.memory.layer.id,
                    filters: '[{"compare":"IN","value":"' + this.map.memory.features.join(',') + '","field":"gid"}]'

                  }).then((response) => {
                    this.messager.Progress('Features retrieved ... processing data', false, null, 'Retrieving data');
                    window.requestAnimationFrame(() => {
                      this.messager.CancelProgress('Retrieving data');
                      if (!response.results || response.results.length === 0) {
                        this.messager.Notify('There was a problem retrieving remembered features for export');
                      }

                      const colDefs = [];
                      const exportData = response.results[0].features;
                      this.SetupColumns(this.map.memory.layer, colDefs);
                      CsvExportService.ExportData(this.messager, colDefs, this.map.memory.layer, exportData, this.rawMode);

                    })

                  });

              }

              /*this.layerAPI.CSVExport(
                this.map.project.id,
                this.map.memory.layer,
                this.map.memory.features as string[],
                'unselected'
              );*/

              break;
            case 'reset-widths':
              const columns = this.gridObj.getColumns();
              let i = 0;
              for (const column of columns) {
                if (i < 2) {
                  i++;
                  continue;
                }
                column.width = 100;
                i++;
              }
              this.gridObj.setColumns(columns);
              break;
            case 'set-raw-mode':
              this.rawMode = true;
              this.ShowLayer(this.selectedIndex);
              break;
            case 'unset-raw-mode':
              this.rawMode = false;
              this.ShowLayer(this.selectedIndex);
              break;
            case 'toggle-grouping-row':
              this.ToggleGroupingRow();
              break;
            case 'toggle-group-summaries':
              this.showGroupSummaries = !this.showGroupSummaries;
              this.grid1.slickGrid.invalidate();
              this.grid1.dataView.refresh();
              break;
            case 'toggle-grand-summary':
              this.showGrandSummary = !this.showGrandSummary;
              this.grid1.slickGrid.invalidate();
              this.grid1.dataView.refresh();
              break;
            case 'toggle-all-columns':
              if (!!e.preventDefault) {
                e.preventDefault();
              }
              const filtered = ColumnFilter.GetColumns();
              const columnDefs = this.gridObj.getColumns();
              const checkboxCol = columnDefs[0];
              if (columnDefs.length > 2) {
                ColumnFilter.currentInstance.Filter(null);
              } else {
                ColumnFilter.currentInstance.clear(true);
              }

            /*const filterCols = ColumnFilter.GetColumns();
            filterCols.unshift(checkboxCol);
            this.gridObj.setColumns(filterCols);
            break;*/
          }

        },
        onBeforeMenuShow: (e, args) => {
          e = null;
          const customItems = $('.slick-gridmenu-custom', args.menu[0]).children();
          let disabled = false;
          const layer = (this.selectedIndex >= 0) ? this.layers[this.selectedIndex] : null;
          const slLayer = this.map.GetLayerById(layer.value);
          let i = -1;
          let filterItem = null;
          let lastItem = null;
          let newLast = null;
          for (const item of customItems) {
            i += 1;
            disabled = false;
            if (!this.dataset) {
              disabled = true;
              this.dataset = [];
            }

            if ($(item).children().length > 0) {

              const children = $(item).children();
              if ($(children[0]).hasClass('export-data')) {
                disabled = !this.CanExport();
              } else if ($(children[0]).hasClass('export-selected')) {


                if (layer && slLayer.access < LayerAccessLevel.Copy) {
                  disabled = true;
                } else if (this.grid1.gridService.getSelectedRows().length === 0) {
                  disabled = true;
                }
              } else if ($(children[0]).hasClass('export-unselected')) {
                if (layer && slLayer.access < LayerAccessLevel.Copy) {
                  disabled = true;
                } else if (this.grid1.gridService.getSelectedRows().length === this.dataset.length) {
                  disabled = true;
                }
              } else if ($(children[0]).hasClass('export-memory')) {
                if (layer && slLayer.access < LayerAccessLevel.Copy) {
                  disabled = true;
                } else if (!!this.map.memory.features) {
                  disabled = this.map.memory.features.length === 0;
                } else {
                  disabled = true;
                }
              } else if ($(children[0]).hasClass('export-all')) {
                if (layer && slLayer.access < LayerAccessLevel.Copy) {
                  disabled = true;
                }
              } else if ($(children[0]).hasClass('export-shp')) {
                if (layer && slLayer.access < LayerAccessLevel.Copy) {
                  disabled = true;
                }

              } else if ($(children[0]).hasClass('export-kmz')) {
                if (layer && slLayer.access < LayerAccessLevel.Copy) {
                  disabled = true;
                }
              } else if ($(children[0]).hasClass('export-excel')) {
                if (layer && slLayer.access < LayerAccessLevel.Copy) {
                  disabled = true;
                }
              } else if ($(children[0]).hasClass('fa-filter')) {
                filterItem = item;
              } else if ($(children[0]).hasClass('fa-random')) {
                $(item).insertBefore(filterItem);
                $(children[0]).toggleClass('fa-filter', true);
                $(children[0]).toggleClass('fa-random', false);
              } else if ($(children[0]).hasClass('fa-unsorted')) {
                lastItem = item;
              } else if ($(children[0]).hasClass('fa-list')) {
                newLast = item;


              }
              /* else if ($(children[0]).hasClass('fa-random')) {
                if (children[1].innerText === 'Toggle Pre-Header Row') {
                  children[1].innerText = 'Toggle Grouping Row';
                  $(children[0]).toggleClass('fa-random', false);
                  $(children[0]).toggleClass('fa-minus', true);
                }
              }
              */

            }
            $(item).attr('disabled', disabled ? 'disabled' : '');
            if (!disabled) {
              $(item).removeAttr('disabled');
            }
            $(item).toggleClass('slick-gridmenu-item-disabled', disabled);
          }
          $(newLast).insertAfter(lastItem);

        }

      },
      defaultColumnWidth: 100,
      footerRowHeight: 32,
      rowSelectionOptions: {
        // True (Single Selection), False (Multiple Selections)
        selectActiveRow: false
      },
      params: {
        angularUtilService: this.angularUtilService // provide the service to all at once (Editor, Filter, AsyncPostRender)
      },
      draggableGrouping: {
        dropPlaceHolderText: 'Drop a column header here to group by the column',
        // groupIconCssClass: 'fa fa-outdent',
        deleteIconCssClass: 'fa fa-times',
        onGroupChanged: (e, args) => { e = null; this.HandleGroupingChange(args); },
        onExtensionRegistered: (extension) => this.draggableGroupingPlugin = extension,
        dropbox: {
          visible: false,
          selector: '.grouping-row'
        }
      }

    }

  }
  ToggleGroupRows(groupingKey: string, onOrOff: boolean) {
    if (typeof groupingKey !== 'string') {
      groupingKey = '';
    }
    const groups = this.grid1.dataView.getGroups();
    let targetGroup = null;
    for (const group of groups) {
      if (group.groupingKey === groupingKey) {
        targetGroup = group;
        break;
      }
    }
    if (!targetGroup) {
      return;
    }
    const rows = targetGroup.rows;
    const selectedRows = this.gridObj.getSelectedRows();
    switch (onOrOff) {
      case true:
        for (const row of rows) {
          const gridRow = this.grid1.dataView.getRowById(row.gid);
          if (selectedRows.indexOf(gridRow) === -1) {
            selectedRows.push(gridRow);
          }
        }
        break;
      case false:
        for (const row of rows) {
          const gridRow = this.grid1.dataView.getRowById(row.gid);
          const entryIndex = selectedRows.indexOf(gridRow);
          if (entryIndex > -1) {
            selectedRows.splice(entryIndex, 1);
          }
        }
        break;
    }

    this.gridObj.setSelectedRows(selectedRows);
  }
  HandleGridClick(event: MouseEvent) {
    const clickTarget = $(event.target).data('click-target');
    if (!!clickTarget) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const targetInfo = clickTarget.split(':');
      switch (targetInfo[0]) {
        case 'group':
          targetInfo.shift();
          const groupingKey = targetInfo.join(':');

          if (!this.groupedRowsVDict.hasOwnProperty(groupingKey)) {
            this.groupedRowsVDict[groupingKey] = true;
          }
          this.groupedRowsVDict[groupingKey] = !this.groupedRowsVDict[groupingKey];
          this.grid1.slickGrid.invalidate();
          this.grid1.dataView.refresh();
          break;
        case 'grand-totals':

          this.groupedRowsVDict.__grandTotal = !this.groupedRowsVDict.__grandTotal;
          this.grid1.slickGrid.invalidate();
          this.grid1.dataView.refresh();
          break;
      }


    }

  }
  HandleGroupingChange(change) {
    if (change && change.caller === 'group-by-drop-start') {
      // this.messager.Progress('Updating data grouping', false, NaN, 'Updating table data');
      return;
    }
    window.requestAnimationFrame(() => {
      const caller = change && change.caller || [];
      const groups = change && change.groupColumns || [];
      const selections = [];
      if (Array.isArray(this.selectedGroupingFields) && Array.isArray(groups) && groups.length > 0) {
        // update all Group By select dropdown
        this.selectedGroupingFields.forEach((g, i) => this.selectedGroupingFields[i] = groups[i] && groups[i].getter || '');
      } else if (groups.length === 0 && caller === '') {
        this.ClearGroupingSelects();
      }
      const newVDict: VDict<AggregatorSet> = {};
      const newValsVDict: VDict<any> = {};
      const newGroupedRowsVDict: VDict<boolean> = {};
      const grandTotalVis = this.groupedRowsVDict.__grandTotal;
      for (const group of this.grid1.dataView.getGroups()) {
        if (!!this.aggregatorsVDict[group.groupingKey]) {
          newVDict[group.groupingKey] = this.aggregatorsVDict[group.groupingKey];
        } else {
          newVDict[group.groupingKey] = new AggregatorSet(true);
          newVDict[group.groupingKey].FromAggColumnInfo(this.aggregatorSet.GetAggColumnInfo());
        }
        if (!!this.groupValuesVDict[group.groupingKey]) {
          newValsVDict[group.groupingKey] = this.groupValuesVDict[group.groupingKey];
        }
        if (this.groupedRowsVDict.hasOwnProperty(group.groupingKey)) {
          newGroupedRowsVDict[group.groupingKey] = this.groupedRowsVDict[group.groupingKey];
        }

      }
      let rowI = -1;
      for (const row of this.grid1.dataView.getRows()) {
        rowI += 1;
        if (row instanceof Slick.NonDataRow) {
          if (row.__group) {
            this.groupedRowSelections = {};
            this.groupedRowSelections[row.groupingKey] = [];
          }
          else {
            if (selections.indexOf(rowI) < 0) {
              selections.push(rowI);
            }
          }
        } else {
          if (selections.indexOf(rowI) < 0) {
            selections.push(rowI);
          }
        }
      }
      this.grid1.gridService.setSelectedRows(selections);

      newGroupedRowsVDict.__grandTotal = grandTotalVis;
      this.aggregatorsVDict = newVDict;
      this.groupValuesVDict = newValsVDict;
      this.groupedRowsVDict = newGroupedRowsVDict;

      this.UpdateSummaries();
      // this.gridObj.invalidateAllRows();
      // this.gridObj.render();
    });
    /*for (const group of this.grid1.dataView.getGrouping()) {
      if (group.aggregators.length === 0) {
        group.aggregators[0] = new AggregatorSet();
        group.aggregators[0].FromAggColumnInfo(this.aggregatorSet.GetAggColumnInfo());
      }
    }*/
    // this.grid1.dataView.setGrouping(this.grid1.dataView.getGrouping());
  }
  ClearGroupingSelects() {
    this.selectedGroupingFields.forEach((g, i) => this.selectedGroupingFields[i] = '');
  }
  ClearGrouping() {
    if (this.draggableGroupingPlugin && this.draggableGroupingPlugin.setDroppedGroups) {
      this.draggableGroupingPlugin.clearDroppedGroups();
    }
    this.gridObj.invalidate(); // invalidate all rows and re-render
  }
  SetMap(map: ISLMap) {
    if (!(!!this.map)) {
      this.map = map;
      this.memoryTools.SetMap(this.map);
      this.map.resultsService.AddSynchable(this.synchProxy);
    }
  }
  ngOnInit() {
    window.addEventListener('resize', () => {
      this.minSize = $('body').hasClass('gt-sm');
      this.UpdateCSS();
    });
    this.minSize = $('body').hasClass('gt-sm');
    this.UpdateCSS();
  }
  ngAfterContentInit() {
    this.dataset = [];

    this.UpdateTabSet();
  }

  AngularGridReady(angularGrid: AngularGridInstance) {
    this.grid1 = angularGrid;
    this.grid1.dataView.setOption('idProperty', 'gid');
    this.gridObj = angularGrid.slickGrid;

    this.grid1.slickGrid.setHeaderRowVisibility(this.gridObj.getOptions().showHeaderRow, false);
    window.requestAnimationFrame(() => {
      if (this.gridOptions.createPreheaderPanel === true) {
        this.grid1.slickGrid.setPreHeaderPanelVisibility(false, false);
      }
    });

    this.grid1.slickGrid.onCellChange.subscribe((e, args) => {
      // this.UpdateSummaries(args.cell, args.grid);
    });
    const me = this;
    this.grid1.slickGrid.onSort.subscribe((_e, _args) => {
      this.UpdateSummaries();
      this.UpdateDisplayState();
      var cols = _args.sortCols;

      this.grid1.dataView.sort(function (dataRow1, dataRow2) {
        for (var i = 0, l = cols.length; i < l; i++) {
          let sortdir = cols[i].sortAsc ? 1 : -1;
          let sortcol = cols[i].sortCol.field;
          me.numberSortFunction = (a, b) => {
            var x = (isNaN(a[sortcol]) || a[sortcol] === "" || a[sortcol] === null) ? -99e+10 : parseFloat(a[sortcol]);
            var y = (isNaN(b[sortcol]) || b[sortcol] === "" || b[sortcol] === null) ? -99e+10 : parseFloat(b[sortcol]);
            return sortdir * (x === y ? 0 : (x > y ? 1 : -1));
          }
          if (cols[i].sortCol) {
            const result = cols[i].sortCol?.sorter(dataRow1, dataRow2); // sorter property from column definition comes in play here
            if (result != 0) {
              return result;
            }
          }
        }
        return 0;
      });
      _args.grid.invalidateAllRows();
      _args.grid.render();

    });
    this.grid1.filterService.onSearchChange.subscribe((e: SlickEvent) => {
      this.UpdateDisplayState();
    });
    this.grid1.slickGrid.onColumnsReordered.subscribe((e, args) => {
      if ((args.columnId === '') || (args.droppedAt === -1)) {
        return;
      }
      if (args.droppedAt < 2) {
        ColumnFilter.MoveColumnTo(args.columnId, 2);
        this.gridObj.setColumns(ColumnFilter.GetColumns());
        this.HandleColumnReorder();
      } else {
        ColumnFilter.MoveColumnTo(args.columnId, args.droppedAt);
        this.HandleColumnReorder();
      }
    });

    for (const viewOption in this.gridOptions.dataView) {
      if (this.gridOptions.dataView.hasOwnProperty(viewOption)) {
        this.grid1.dataView.setOption(viewOption, this.gridOptions.dataView[viewOption]);
      }
    }
    // this.dataViewObj = angularGrid.dataView;
    if (!!this.height) {
      this.UpdateHeight(this.height);
    }
    if (this.selectedFeatureIndex !== -1) {
      const selectedFeatureRow = this.grid1.dataView.getRowById(this.selectedFeatureIndex);
      this.selectedRows = [selectedFeatureRow];
    }

    if (this.selectedRows.length > 0) {
      this.gridObj.setSelectedRows(this.selectedRows);
      if (this.selectedRows.length > 1) {
        const firstRow = this.selectedRows[0];
        this.gridObj.scrollRowIntoView(firstRow);
      }
      this.SelectionsChanged();
    } else {
      this.gridObj.setSelectedRows([]);
      // this.gridObj.scrollRowIntoView(0);
    }

    $('#resultsGrid', this.domNode.nativeElement).on('click', (event) => {
      let target = event.originalEvent.target as any;

      if (target.localName === 'span') {
        target = target.parentNode;
      }
      if (target.classList.contains('grouping-title') || target.classList.contains('slick-group-title')) {
        if (target.classList.contains('slick-group-title')) {
          target = $('.grouping-title', target)[0];
        }
        if (target.classList.contains('all-on') === true) {
          this.ToggleGroupRows(target.dataset.groupid, false);
        } else {
          this.ToggleGroupRows(target.dataset.groupid, true);

        }

      }
      if (target.attributes.hasOwnProperty('data-role') === false) { return; }
      if (!(!!target.attributes['data-gid'].value)) { return; }
      if (this.selectedIndex < 0) { return; }
      const gid = target.attributes['data-gid'].value;
      const layerId = this.results[this.selectedIndex].layer;
      const layer: SLLayer = this.map.GetLayerById(layerId);
      const params: any = {};
      switch (target.attributes['data-role'].value) {
        case 'zoom-to':
          this.map.component.HandleToolAction({
            action: 'info/zoom-to-features',
            layer: layerId,
            features: [gid]
          });
          break;
        case 'feature-edit':
          params.layer = layer;
          params.action = 'info/feature-edit';
          params.gid = gid;
          params.feature = this.grid1.dataView.getItemById(params.gid);
          params.data = 'geom';
          this.map.component.HandleToolAction(params);
          break;
        case 'view-attributes':
          this.ShowInInfo(layer, gid);
          /* params.layer = layer;
          params.action = 'info/view-attributes';
          params.gid = gid;
          this.map.component.HandleToolAction(params);
          */
          break;
        case 'query-by-feature':
          params.featureLayer = layer.id;
          params.action = 'info/query-by-feature';
          params.gids = [gid];
          params.visOnly = false;
          this.map.component.HandleToolAction(params);
          break;
        case 'query-by-feature-vis':
          params.featureLayer = layer.id;
          params.action = 'info/query-by-feature';
          params.gids = [gid];
          params.visOnly = true;
          this.map.component.HandleToolAction(params);
          break;
        case 'drop-result':

          const selRows = this.selectedRows;
          const stillSelRows = [];
          let selRow = null;
          for (const row of selRows) {
            const rowIndex = this.grid1.gridService.getDataItemByRowIndex(row);
            if (!!rowIndex) {
              const rowId = this.grid1.gridService.getDataItemByRowIndex(row).gid;
              if (gid !== rowId) {
                stillSelRows.push(rowId);
                selRow = row;
              }
            }
          }
          this.grid1.gridService.deleteItemById(gid);
          this.grid1.dataView.refresh();

          this.gridObj.setSelectedRows([]);
          const stillSelections = [];
          for (const stillItem of stillSelRows) {
            const row = this.grid1.dataView.getRowById(stillItem);
            stillSelections.push(row);
          }
          if (selRow !== null) {
            this.gridObj.scrollRowIntoView(selRow);
          }

          this.gridObj.setSelectedRows(stillSelections);
          this.layers[this.selectedIndex].count = this.results[this.selectedIndex].features.length;
          break;
      }
    });

  }

  UpdateTabSet() {
    this.tabsReady = false;
    setTimeout(() => {
      this.tabsReady = true;
      this.UpdateCSS();
    }, 50);
  }
  UpdateGrid(restoring: boolean = false, handler?: SimpleHandler) {
    if (this.gridObj) {
      this.gridReady = false;
    }
    if (!this.grid1) return;
    if (this.columnDefinitions.length === 0) {
      if (this.gridObj) {
        this.gridObj.columns = [];
      }
      this.grid1?.resizerService?.pauseResizer(true);
    } else {
      this.grid1?.resizerService?.pauseResizer(false);
    }
    if (this.results.length === 0) { return; }
    setTimeout(() => {
      this.gridReady = true;
      setTimeout(() => {
        this.gridObj = this.grid1.slickGrid;

        const layerId = this.results[this.selectedIndex].layer;
        this.grid1.slickGrid.navigateTop();
        if (!!handler) {
          handler();
        }
        ColumnFilter.SetColumns(this.grid1.slickGrid.getColumns());
        let hadDisplayState = false;
        if (restoring === true) {
          this.RestoreDisplayState();

        } else {
          this.UpdateDisplayState();
          this.ToggleGroupingRow(false);
        }

      }, 20);
    }, 10);
  }
  UpdateHeight(height: number) {
    if (!!this.columnDefinitions && this.columnDefinitions.length === 0) return true;

    this.height = height;

    if (!!this.grid1) {
      const elements = $('#resultsGrid', this.domNode.nativeElement);
      if (elements.length === 1) {
        const gridContainer = elements[0] as HTMLDivElement;
        gridContainer.style.setProperty('height', this.ComputeHeight(height));
        if (this.height > 0) {
          if (this.gridObj) {
            const offHeight = gridContainer.offsetHeight;
            this.grid1?.resizerService?.resizeGrid(0, { height: offHeight });

          }
        }
      }

    }
    this.zoomToTools.UpdateHeight();
    this.memoryTools.UpdateHeight();
    this.selectTools.UpdateHeight();
  }
  UpdateViewPortHeight(height: number) {
    if (this.gridOptions.draggableGrouping.dropbox && !!this.gridOptions.draggableGrouping.dropbox.visible) {
      $('.slick-viewport').css('height', `calc(${height}px - 8.5em)`);
      return;
    }
    $('.slick-viewport').css('height', `calc(${height}px - 9.5em)`);
    return;
  }

  public gridHeight = '0px';
  ComputeHeight(height: number) {
    this.gridHeight = `calc(${height}px - var(--tabs-height) - var(--subnav-height) - var(--grouping-bar-height))`;
    this.domNode.nativeElement.style.setProperty('--grid-height', this.gridHeight);

    return this.gridHeight;
    if (this.gridOptions.draggableGrouping.dropbox && !!this.gridOptions.draggableGrouping.dropbox.visible) {
      return `${height - 110}px`;
      // return `calc(${height}px - 5.0em)`;
    }
    return `${height - 75}px`
    // return `calc(${height}px - 6.5em)`;
  }
  UpdateFeature(layerId: string | number, featureId: string | number, feature: any) {
    if (this.dataset.length === 0) {
      return;
    }
    featureId = null;
    for (const result of this.results) {
      if (result.layer === layerId) {
        try {
          this.grid1.gridService.updateItem(feature);
        } catch (e) {
          // wasn't found nothing to do;
        }
      }

    }
    this.grid1.dataView.refresh();
    // this.UpdateGrid();
  }
  ShowResultMoment(moment: ResultMoment, selectedLayer?: SLLayer, selectedFeature?: any, showInfo: boolean = false) {

    if ((!this.moment) || (this.moment.id !== moment.id)) {
      this.groupValuesVDict = {};
      this.aggregatorsVDict = {}
      this.groupedRowsVDict = {};
      this.groupedRowsVDict.__grandTotal = true;
      this.aggregatorSet = new AggregatorSet(false);
      this.moment = moment;
      this.resultsSvc.history.RegisterSynch(this.synchProxy.synchId, this.moment.id);
      this.synchProxy.channel = this.moment.id;
      const results = this.moment.resultSet.results;
      this.ShowResults(results, selectedLayer, selectedFeature, showInfo);
      if (!!moment.resultSet.displayedLayers) {
        this.selections = moment.resultSet.displayedLayers;
      }
    }
    this.UpdateTabSet();
    this.UpdateCSS();
  }
  ShowResults(results: Array<any>, selectedLayer: SLLayer = null, selectedFeature: any = null,
    showInfo: boolean = false) {
    this.selectedFeatureIndex = -1;
    const newResults = [];

    for (const r of results) {
      newResults.push(r);
    }
    if (showInfo === true) {
      if (newResults.length === 1) {
        if (newResults[0].features.length === 1) {
          let lIdx = 0;
          for (const oldResult of this.results) {
            if (oldResult.layer === newResults[0].layer) {
              this.selectedIndex = lIdx;
              for (const oldFeature of oldResult.features) {
                if (oldFeature.gid === newResults[0].features[0].gid) {
                  this.ShowInInfo(this.map.GetLayerById(newResults[0].plid, true), selectedFeature);
                  return;
                }
              }

            }
            lIdx++;
          }

        }
      }
    }

    this.selectedIndex = -1;
    this.selectedRows = [];
    this.gridReady = true;
    this.tabsReady = false;
    this.results.splice(0);
    let selIndex = 0;
    let ctr = 0;
    if (!selectedLayer) {
      selectedLayer = results[0]?.layer;
    }

    for (const result of newResults) {
      this.results.push(result);
      if (!!selectedLayer) {
        if (result.layer === selectedLayer) {
          selIndex = ctr;
        }
      }
      ctr += 1;
    }

    this.SetupLayers();
    if (this.results.length > 0) {
      if (selIndex === -1) {
        selIndex = 0;
      }
      this.ShowLayer(selIndex, () => {
        if (!!selectedFeature) {
          this.SelectFeature(selectedFeature);
          if (showInfo === true) {
            this.ShowInInfo(this.map.GetLayerById(this.results[selIndex].plid, true), selectedFeature);
          }
        } else {
          this.selectedFeatureIndex = -1;
          this.SelectAllFeatures();
        }
        this.UpdateResultMetaStats();

        this.UpdateSummaries();
      });


    } else {
      this.hasResults = false;

      this.UpdateGrid();
    }
    this.UpdateResultMetaStats();
    this.map.SetHasResults(this.hasResults === true);

    if (this.hasResults === true) {
      this.UpdateTabSet();
    }
    this.UpdateCSS();

  }

  UpdateSelections(info: ISelectionInfo) {
    const layerIndex = this.GetLayerIndex(info.layer);
    this.selectMode = info.selectionMode;

    if (this.selectedIndex !== layerIndex) {
      if (layerIndex === -1) {
        this.SelectFeature(null, true);
        return;
      }

      this.ShowLayer(layerIndex, () => {
        this.SelectFeature(info.features[0], true);
      });
    } else {
      this.SelectFeature(info.features[0], true);
    }

  }
  SetupLayers(): void {
    this.layers.splice(0);

    this.selections = {};
    if (!!this.moment) {
      if (!!this.moment.resultSet.displayedLayers) {
        this.selections = this.moment.resultSet.displayedLayers;
      }
    }
    for (const item of this.results) {
      this.layers.push({ value: item.layer, name: item.layer_name, bbox: item.layer_bbox, count: item.features.length });
      if (!(!!this.moment)) {
        this.selections[item.layer.id] = true;
      }
    }
  }
  ShowLayer(itemIndex: number, handler?: SimpleHandler) {
    this.gridReady = false;
    delete this.gridObj;
    if (this.results.length === 0) { return; }
    this.selectedFeatureIndex = -1;
    this.selectedIndex = itemIndex;
    this.selectedRows = [];
    const layerId = this.results[itemIndex].layer;

    this.hadDisplaySettings = !!this.moment.displayStates[layerId];
    const layer: SLLayer = this.map.GetLayerById(layerId);
    (this.domNode.nativeElement as HTMLElement).classList.toggle('layer-access-edit', layer.access >= AccessLevels.EDIT)

    this.dataset = [];
    $('.grid-container').toggleClass('copyable', Number(layer.access) >= AccessLevels.COPY);
    this.columnDefinitions = []

    // this.gridObj.setColumns(this.columnDefinitions);

    // const attributes = layer.layerAttributes;
    this.aggregatorSet = new AggregatorSet(false);
    this.groupValuesVDict = {};
    this.groupedRowsVDict = {};
    this.aggregatorsVDict = {};
    this.groupedRowsVDict.__grandTotal = true;
    this.SetupColumns(layer, this.columnDefinitions);
    /*this.columnDefinitions.push({
      id: '_sl_actions',
      name: '',
      field: 'gid',
      sortable: false,
      filterable: true,
      maxWidth: 260,
      width: (layer.access > AccessLevels.READ) ? 260 : 196.5,
      formatter: ActionsFormatter.Format,
      cssClass: 'sl-actions',
      excludeFromColumnPicker: true,
      excludeFromGridMenu: true,
      filter: {
        model: ColumnFilter
      },
      params: {
        excludeFromColumnPicker: true,
        excludeFromGridMenu: true,
        excludeFromExport: true,
        access: layer.access,
        type: 'integer',
        startIndex: 2
      }
    });
    for (const attribute of attributes) {
      let type: AttStorageType | AttributeRequirement = attribute.type === undefined ? attribute.requires : attribute.type;
      if (attribute.requires === 'url') {
        type = 'url';
      }
      const columnDef: Decorable = {
        id: attribute.name,
        name: ColumnFormatter.FormatHeader(attribute),
        field: attribute.name,
        sortable: true,
        params: ({
          attribute: (attribute),
          rawMode: this.rawMode,
          summaries: {
            count: false,
            min: false,
            max: false,
            first: false,
            last: false,
            avg: false,
            median: false,
            stddev: false
          }
        } as any),
        formatter: ColumnFormatter.Format,
        grouping: {
          getter: attribute.name,
          formatter: (g) => {
            return `Group (${g.count}) ${attribute.display} = ${g.value}</span>`;
          },
          customGroupRows: this.customGroupRows,
          displayTotalsRow: true,
          aggregateCollapsed: false,
          collapsed: false
        },
        groupTotalsFormatter: (totals: any, columnDef: Column, grid?: any) => {
          let cellContent = '';
          let ctr = 0;
          for (const aggregator of columnDef.grouping.aggregators) {
            const agg = aggregator as SLAggregator;
            if (agg instanceof NoneAggregator) {
              continue;
            }
            const name = agg.GetName();
            if (!totals[name]) {
              continue;
            }
            if (!totals[name][columnDef.id]) {
              continue;
            }
            const value = totals[name][columnDef.id];
            ctr += 1;
            if (!!totals[agg.GetName()]) {
              const title = `${columnDef.name} &#8212; ${agg.GetLabel()}: ${value} `;
            }
          }
          return cellContent;
        }
      };
      if (attribute.name === 'id') {
        columnDef.id = '--ID--';
        columnDef.field = '--ID--';
      }
      switch (type) {
        case 'cg_url':
        case 'url':
          columnDef.width = 200;
          columnDef.cssClass = 'sl-url';
          columnDef.params.excludeFromExport = false;
          columnDef.filterable = true;
          break;
        case 'time':
        case 'date':
          // columnDef.formatter = Formatters.dateTimeIso;
          columnDef.width = 100;
          columnDef.filterable = true;
          columnDef.headerCssClass = 'sl-date';
          break;
        case 'boolean':
          // columnDef.formatter = Formatters.checkmark;
          columnDef.width = 100;
          columnDef.filterable = true;
          columnDef.headerCssClass = 'sl-boolean';
          break;
        case 'numeric':
        case 'float':
        case 'int':
        case 'text':
        case 'string':
        default:
          columnDef.width = 100;
          columnDef.filterable = true;
          columnDef.headerCssClass = 'sl-' + type;
          break;
      }
      columnDef.headerCssClass += ' sl-col-' + columnDef.id;
      this.columnDefinitions.push(columnDef);
    }
    */
    this.dataset = this.results[itemIndex].features;
    /* For loop that was setting id field;
    this.dataset = [];
    let rowI = 0;
    for (const feature of this.results[itemIndex].features) {
      if (feature.hasOwnProperty('id') === true) {
        feature['--ID--'] = feature.id;
        feature.id = feature.gid;
      } else {
        feature.id = feature.gid;
      }

      this.dataset.push(feature);
      if (this.handlingResultChange === false) {
        this.selectedRows.push(rowI);
      }
      rowI++;
    }*/

    /*this.gridObj.setColumns(this.columnDefinitions);
    this.gridObj.setData(this.dataset);
    this.grid1.gridService.init(this.gridObj, this.dataViewObj);
    this.grid1.resizerService.resizeGrid();
    this.gridObj.invalidate();
    */
    // this.UpdateTabSet();
    this.UpdateGrid(this.hadDisplaySettings, handler);
    // this.UpdateSummaries();

    // this.grid1.gridStateService.resetColumns(this.columnDefinitions as Array<Column>);
  }
  SetupColumns(layer, columnDefinitions: Array<any>) {


    // this.gridObj.setColumns(this.columnDefinitions);

    const attributes = layer.layerAttributes;
    const isViewer = this.env.GetAppNameFromURL(true) === 'viewer';

    columnDefinitions.push({
      id: '_sl_actions',
      name: '',
      field: 'gid',
      sortable: false,
      filterable: true,
      maxWidth: (layer.access > AccessLevels.READ) ? (isViewer ? 6 : 5) * (1.8 * 16) + (4 * (.125 * 16)) : (isViewer ? 5 : 4) * (1.8 * 16) + (3 * (.125 * 16)),
      width: (layer.access > AccessLevels.READ) ? (isViewer ? 6 : 5) * (1.8 * 16) + (4 * (.125 * 16)) : (isViewer ? 5 : 4) * (1.8 * 16) + (3 * (.125 * 16)),
      minWidth: (layer.access > AccessLevels.READ) ? (isViewer ? 6 : 5) * (1.8 * 16) + (4 * (.125 * 16)) : (isViewer ? 5 : 4) * (1.8 * 16) + (3 * (.125 * 16)),
      formatter: ActionsFormatter.Format,
      cssClass: 'sl-actions',
      excludeFromColumnPicker: true,
      excludeFromGridMenu: true,
      filter: {
        model: ColumnFilter
      },
      params: {
        excludeFromColumnPicker: true,
        excludeFromGridMenu: true,
        excludeFromExport: true,
        access: layer.access,
        type: 'integer',
        startIndex: 2
      }

    });
    for (const attribute of attributes) {

      let type: AttStorageType | AttributeRequirement = attribute.type === undefined ? attribute.requires : attribute.type;
      if (attribute.requires === 'url') {
        type = 'url';
      }
      if (!AttributesService.IsVisible(attribute)) continue;
      const columnDef: Decorable = {
        id: attribute.name,
        name: ColumnFormatter.FormatHeader(attribute),
        field: attribute.name,
        sortable: true,
        visible: true,
        params: ({
          attribute: (attribute),
          rawMode: this.rawMode,
          summaries: {
            count: false,
            min: false,
            max: false,
            first: false,
            last: false,
            avg: false,
            median: false,
            stddev: false
          }
        } as any),
        formatter: ColumnFormatter.Format,
        grouping: {
          getter: attribute.name,
          formatter: (g: any, asHTML = false) => {
            const val = ColumnFormatter.Format(null, null, g.value, { params: { attribute: (attribute) } }, this.gridObj);
            const disabled = (g.collapsed === 1) ? 'disabled' : '';
            const allOn = (this.groupedRowSelections[g.groupingKey] && (g.rows.length === this.groupedRowSelections[g.groupingKey].length)) ? 'all-on' : '';
            return `<span class="grouping-title ${allOn} ${disabled}" data-groupId="${g.groupingKey}" > Group(${g.count}) ${attribute.display} = ${val} </span>`;
          },
          customGroupRows: this.customGroupRows,
          displayTotalsRow: true,
          aggregateCollapsed: false,
          collapsed: false

        },
        groupTotalsFormatter: (totals: any, columnDef: Column, grid?: any) => {
          let cellContent = '';
          let ctr = 0;

          for (const aggregator of columnDef.grouping.aggregators) {
            const agg = aggregator as SLAggregator;
            if (agg instanceof NoneAggregator) {
              continue;
            }
            const name = agg.GetName();
            if (!totals[name]) {
              continue;
            }
            if (!totals[name][columnDef.id]) {
              continue;
            }
            const value = totals[name][columnDef.id];
            ctr += 1;
            if (!!totals[agg.GetName()]) {
              const title = `${columnDef.name} &#8212; ${agg.GetLabel()}: ${value} `;
              cellContent += `< div class="${name}" > <label class="agg-label" > ${agg.GetLabel()} </label><span class="agg-value" title="${title}">${value}</span > </div>`
            }

          }

          return cellContent;
        }
      };

      /*if (attribute.name === 'id') {
        columnDef.id = '--ID--';
        columnDef.field = '--ID--';
        columnDef.grouping.getter = '--ID--';
      }*/

      switch (type) {
        case 'cg_url':
        case 'url':
          columnDef.width = 200;
          columnDef.cssClass = 'sl-url';
          columnDef.params.excludeFromExport = false;
          columnDef.filterable = true;
          break;
        case 'time':
        case 'date':
          // columnDef.formatter = Formatters.dateTimeIso;
          columnDef.width = 100;
          columnDef.filterable = true;
          columnDef.headerCssClass = 'sl-date';
          break;
        case 'boolean':
          // columnDef.formatter = Formatters.checkmark;
          columnDef.width = 100;
          columnDef.filterable = true;
          columnDef.headerCssClass = 'sl-boolean';
          break;
        case 'numeric':
        case 'float':
        case 'int':
        case 'integer':
          if (this.numberSorter) {
            columnDef.sorter = this.numberSorter;
          }
        case 'text':
        case 'string':
        default:
          columnDef.width = 100;
          columnDef.filterable = true;
          columnDef.headerCssClass = 'sl-' + type;
          break;
      }
      columnDef.headerCssClass += ' sl-col-' + columnDef.id;
      columnDefinitions.push(columnDef);

    }
  }
  UpdateLayer() {
    if (this.results.length === 0) { return; }
    const anchorColumn = this.anchorColumn;
    const grouping = this.grid1.dataView.getGrouping();
    // this.selectedFeatureIndex = -1;
    this.selectedRows = [];
    const layerId = this.results[this.selectedIndex].layer;
    const layer: SLLayer = this.map.GetLayerById(layerId);
    this.dataset = [];

    const columnDefs = this.gridObj.getColumns();
    columnDefs.splice(0, 1);
    this.columnDefinitions = columnDefs;
    // this.gridObj.setColumns(this.columnDefinitions);

    const attributes = layer.layerAttributes;



    for (const attribute of attributes) {

      let type: AttStorageType | AttributeRequirement = attribute.type === undefined ? attribute.requires : attribute.type;
      if (attribute.requires === 'url') {
        type = 'url';
      }
      const columnDef = this.GetColumnByName(attribute.name);
      if (!columnDef) {
        continue;
      }
      columnDef.name = ColumnFormatter.FormatHeader(attribute);
      columnDef.params = ({
        attribute: (attribute),
        rawMode: this.rawMode,
        summaries: {
          count: false,
          min: false,
          max: false,
          first: false,
          last: false,
          avg: false,
          median: false,
          stddev: false
        }
      } as any);

      if (attribute.name === 'id') {
        columnDef.id = '--ID--';
        columnDef.field = '--ID--';
      }

      switch (type) {
        case 'cg_url':
        case 'url':
          columnDef.width = 200;
          columnDef.cssClass = 'sl-url';
          columnDef.params.excludeFromExport = false;
          columnDef.filterable = true;
          break;
        case 'time':
        case 'date':
          // columnDef.formatter = Formatters.dateTimeIso;
          columnDef.width = 100;
          columnDef.filterable = true;
          columnDef.headerCssClass = 'sl-date';
          break;
        case 'boolean':
          // columnDef.formatter = Formatters.checkmark;
          columnDef.width = 100;
          columnDef.filterable = true;
          columnDef.headerCssClass = 'sl-boolean';
          break;
        case 'numeric':
        case 'float':
        case 'int':
        case 'text':
        case 'string':
        default:
          columnDef.width = 100;
          columnDef.filterable = true;
          columnDef.headerCssClass = 'sl-' + type;
          break;
      }
      columnDef.headerCssClass += ' sl-col-' + columnDef.id;

    }
    this.dataset = [];
    for (const feature of this.results[this.selectedIndex].features) {
      if (feature.hasOwnProperty('id') === true) {
        feature['--ID--'] = feature.id;
        feature.id = feature.gid;
      } else {
        feature.id = feature.gid;
      }

      this.dataset.push(feature);
      const rowI = this.grid1.dataView.getRowById(feature.gid);
      this.selectedRows.push(rowI);

    }

    this.UpdateGrid(true);
    //this.UpdateSummaries();



    // this.grid1.gridStateService.resetColumns(this.columnDefinitions as Array<Column>);
  }
  HandleTab(layer: Dict, event: Event) {
    event.preventDefault();
    event.cancelBubble = true;
    if (this.layers.indexOf(layer) === this.selectedIndex) {
      return;
    }
    const newLayerIndex = this.layers.indexOf(layer);;
    if (this.selectedIndex === newLayerIndex) {
      this.UpdateLayer();
      return;
    }
    this.selectedIndex = this.layers.indexOf(layer);
    this.isSettingSelections = true;
    // this.SelectAllFeatures();
    this.ShowLayer(this.selectedIndex, () => {



    if (this.selectedFeatureIndex >= 0) {
      this.SelectFeature(this.layers[this.selectedIndex].features[this.selectedFeatureIndex]);

    } else {
      this.SelectAllFeatures();
    }
    window.requestAnimationFrame(() => {
      this.isSettingSelections = false;
    });

  });

}
SelectLayers() {
  const layerList: Array<SLLayer> = [];
  for (const item of this.layers) {
    const layer: SLLayer = this.map.GetLayerById(item.value);
    layerList.push(layer);
  }
  this.layerSelector.ListSLLayerSet(layerList, true, this.selections, (resposne: any) => {

    this.selections = resposne.selections;
    // this.UpdateTabSet();

  });
}
SelectFeature(feature: any, autoSet ?: boolean) {
  if (this.selectedIndex === -1) {
    return;
  }
  if (!(!!autoSet)) { autoSet = false; }
  if (!this.gridObj) {
    window.requestAnimationFrame(() => {
      this.SelectFeature(feature, autoSet);

    });
    return;
  }
  /*if (autoSet === true) {
    if (feature === null) {
      this.gridObj.setSelectedRows([]);
      this.gridObj.scrollRowIntoView(0);
      return;
    }

  }*/
  let i = 0;
  let selectedFeature = null;
  for (const resultFeature of this.results[this.selectedIndex].features) {
    if (resultFeature.gid === feature) {
      this.selectedFeatureIndex = i;
      selectedFeature = resultFeature;
      break;
    }
    i++;
  }
  if (autoSet === true) {
    const row = this.grid1.dataView.getRowById(this.dataset[this.selectedFeatureIndex].gid);
    this.selectedRows = [row];

    this.gridObj.setSelectedRows(this.selectedRows);
    this.gridObj.scrollRowIntoView(this.selectedFeatureIndex);
  }
  this.UpdateResultMetaStats();
}
GetLayerIndex(selectedLayer: any): number {
  if (typeof selectedLayer === 'object') { selectedLayer = selectedLayer.id; }
  let ctr = 0;
  let selIndex = -1;
  for (const result of this.results) {
    if (result.layer === selectedLayer) {
      selIndex = ctr;
    }
    ctr += 1;
  }
  return selIndex;
}
GetResults() {
  const data: any = { results: this.results };

  if (this.selectedIndex > -1) {
    const resultLayer = this.results[this.selectedIndex];
    const isProjectLayer = !!resultLayer.plid;
    const layerId = (isProjectLayer) ? resultLayer.plid : resultLayer.layer;
    const layer = this.map.GetLayerById(layerId, isProjectLayer);
    data.selectedLayer = layer;
    if (this.selectedFeatureIndex > -1) {
      const feature = resultLayer.features[this.selectedFeatureIndex];
      data.selectedFeature = feature.gid;
    }
  }
  return data;
}
HandleSelectionsChanged(e: any = null) {
  if (e) {
    e.stopImmediatePropagation();
  }
  if (e?.detail?.eventData) {
    this.isSettingSelections = true;
    this.SelectionsChanged(e.detail.eventData);
    this.isSettingSelections = false;
  }
}
SelectionsChanged(e = null) {
  e = null;
  if (this.results.length === 0) {
    return;
  }
  this.selectedFeatureIndex = -1;
  const features = [];
  if (this.selectedIndex === -1) {
    return;
  }
  const unfeatures = [];
  for (const feature of this.results[this.selectedIndex].features) {
    unfeatures.push(feature.gid);
  }
  const oldRows = this.selectedRows;
  let newRows = this.gridObj.getSelectedRows();
  if (this.selectMode === 'single') {
    if (newRows.length > 1) {
      newRows = newRows.filter((entry: any) => {
        this.UpdateMultiSelect();
        return oldRows.indexOf(entry) < 0;
      });
      if (newRows.length > 0) {
        newRows = [newRows.shift()];
        this.selectedRows = newRows;
        this.gridObj.setSelectedRows(this.selectedRows);
        this.UpdateMultiSelect();
        return;
      }

    }
  }

  this.selectedRows = newRows;
  if (this.selectedRows.length > 1) {
    this.selectMode = 'multi';
  }
  let lastGroup = null;
  let lastGroupRowI = null;
  this.groupedRowSelections = {};
  if (this.selectedRows && this.results.length > 0) {
    if (this.selectedRows.length > 0) {
      let rowI = -1;
      for (const row of this.grid1.dataView.getRows()) {
        rowI++;
        if (row instanceof Slick.NonDataRow) {
          if (row.__group) {
            if (lastGroup) {
              if (this.groupedRowSelections['' + lastGroup.groupingKey]) {
                if (this.groupedRowSelections['' + lastGroup.groupingKey].length === lastGroup.rows.length) {
                  if (this.selectedRows.indexOf(lastGroupRowI) === -1) {
                    this.selectedRows.push(lastGroupRowI);

                  }
                }
              }
            }
            lastGroup = row;
            lastGroupRowI = rowI;
            const key = '' + lastGroup.groupingKey;
            this.groupedRowSelections[key] = [];

          }
          if (row.__custom) {
            if (this.selectedRows.indexOf(rowI) === -1) {
              this.selectedRows.push(rowI);
            }
          }
          continue;
        } else {
          const feature = row;
          if (!!feature) {
            if (this.selectedRows.indexOf(rowI) > -1) {
              if (!!lastGroup) {
                const key = '' + lastGroup.groupingKey;
                if (this.groupedRowSelections[key].indexOf(feature.gid) === -1) {
                  this.groupedRowSelections[key].push(feature.gid);
                }
              }
              features.push(feature.gid);
              unfeatures.splice(unfeatures.indexOf(features[features.length - 1]), 1);

            }

          }

        }

      }
      if (lastGroup) {
        if (lastGroup) {
          if (this.groupedRowSelections['' + lastGroup.groupingKey]) {
            if (this.groupedRowSelections['' + lastGroup.groupingKey].length === lastGroup.rows.length) {
              this.selectedRows.push(lastGroupRowI);
            }
          }
        }
      }
      if (this.selectedRows.length !== this.gridObj.getSelectedRows().length) {
        this.gridObj.setSelectedRows(this.selectedRows);
      }
    }
  }
  const result = this.results[this.selectedIndex];
  if (!result) {
    return;
  }
  const isProjectLayer = !!result.plid;

  const layerId = (isProjectLayer) ? result.plid : result.layer;
  let selections: ISelectionInfo = null;
  if (this.isSettingSelections === false) {
    selections = {
      id: UUID.UUID(),
      layer: this.map.GetLayerById(layerId, isProjectLayer),
      layerId: (layerId),
      features: (features),
      unfeatures: (unfeatures),
      selectionMode: this.selectMode
    }

    this.resultsSvc.history.RegisterSelection(this.synchProxy.synchId, selections.id);
  } else {
    if (!this.currentSelections) {
      (this.currentSelections as any) = { id: UUID.UUID() };
    }
    if (this.currentSelections.layer && this.currentSelections.layerId !== layerId) {
      this.currentSelections.id = UUID.UUID();
    }
    this.currentSelections.layer = this.map.GetLayerById(layerId, isProjectLayer);
    this.currentSelections.layerId = layerId;
    this.currentSelections.features = features;
    this.currentSelections.unfeatures = unfeatures;
    this.currentSelections.selectionMode = this.selectMode;
    selections = this.currentSelections;
    this.resultsSvc.history.RegisterSelection(this.synchProxy.synchId, selections.id);

  }
  if (this.currentSelections != null) {
    /*if (this.currentSelections.id === selections.id) {
      return;
    }*/
    /* if (this.resultsSvc.CompareSelections(this.currentSelections, selections)) {
      return;
    }*/

  }
  if (this.isSettingSelections === false) {
    return;
  }
  this.currentSelections = selections;
  const synchTo: Array<string> = [];
  if (this.infoSynching) {
    synchTo.push('info');
  }
  if (this.pucSynching) {
    synchTo.push('popup-control');
  }
  this.resultsSvc.history.synchResultsSet[this.synchProxy.synchId] = selections.id;

  const event: SynchSelectionsEvent = {
    channel: this.moment.id,
    source: this.synchProxy.synchId,
    topic: 'selection-change',
    data: { moment: (this.moment), selections: (selections) },
    synchTo: (synchTo.join(',')),
    synchFrom: this.synchProxy.synchId
  }
  if (synchTo.length > 0) {
    this.resultsSvc.Synch(event);
  }
  const renderEvent: SynchSelectionsEvent = {
    channel: 'renderer',
    source: this.synchProxy.synchId,
    topic: 'render',
    data: { moment: (this.moment), selections: (selections) }
  }
  this.resultsSvc.Synch(renderEvent);

  this.UpdateMultiSelect();
  /* this.map.ShowResult(
    {
      layerId: (layerId),
      layer: this.map.GetLayerById(layerId, isProjectLayer),
      features: (features),
      unfeatures: (unfeatures),
      channel: this.synchProxy.channel,
      context: 'results-list-selection'
    }
  );
  */

  this.UpdateSummaries();
  this.UpdateResultMetaStats();
}
SelectAllFeatures() {
  this.selectedFeatureIndex = -1;
  this.selectedRows = [];
  if (!this.results) {
    return;
  }
  if (!this.selectedIndex && this.selectedIndex !== 0) {
    return;
  }
  if (!this.results[this.selectedIndex].features) {
    return;
  }
  const features = this.results[this.selectedIndex].features;
  const rows = this.grid1.dataView.getRows();
  for (let row = 0, l = rows.length; row < l; row++) {
    if (rows[row] instanceof (Slick.NonDataRow)) {
      continue;
    }
    this.selectedRows.push(row);
  }
  this.grid1.gridService.setSelectedRows(this.selectedRows);
  const wasSettingSelections = this.isSettingSelections;
  this.isSettingSelections = true;
  this.SelectionsChanged();
  this.isSettingSelections = wasSettingSelections;

}
RenderAngularComponent(cellNode: HTMLElement, row: number, dataContext: any, colDef: Column) {
  if (!!colDef.params.component) {
    const component: any = colDef.params.component;

    const componentOutput: AngularComponentOutput =
      this.angularUtilService.createAngularComponent(
        component
      );
    const layerId = this.results[this.selectedIndex].layer;
    const layer: SLLayer = this.map.GetLayerById(layerId);
    const componentInstance: IColumnComponent = componentOutput.componentRef.instance as IColumnComponent;
    componentInstance.SetData(cellNode, row, dataContext,
      colDef, this.map, layer);
    // Object.assign(componentOutput.componentRef.instance, { item: dataContext });
    // use a delay to make sure Angular ran at least a full cycle and it finished rendering the Component
    setTimeout(() => $(cellNode).empty().html(componentOutput.domElement));
  }
}
GetRecordsByIds(ids: Array<any>) {
  const records = [];
  for (const id of ids) {
    const record = this.grid1.dataView.getItemById(id);
    if (record) {
      records.push(record);
    }
  }
  return records;
}
GetRows() {
  return this.grid1.dataView.getRows();

}
GetRecords(subset: 'all' | 'selected' | 'unselected') {
  const selRows = this.grid1.gridService.getSelectedRows();
  const selItems = [];
  const selIds = [];
  for (const selItem of selRows) {
    selItems.push(this.grid1.gridService.getDataItemByRowIndex(selItem));
    selIds.push(this.grid1.gridService.getDataItemByRowIndex(selItem).gid);
  }
  if (subset === 'selected') {
    return selItems;
  }
  const allItems = [];
  for (const item of this.dataset) {
    allItems.push(item);
  }
  switch (subset) {
    case 'all':
      return allItems
    case 'unselected':
      return allItems.filter(n => !selIds.includes(n.gid));
  }
}
GetGIDs(subset: string) {
  const selRows = this.grid1.gridService.getSelectedRows();
  const selIds = [];
  for (const selItem of selRows) {
    selIds.push(this.grid1.gridService.getDataItemByRowIndex(selItem).gid);
  }
  if (subset === 'selected') {
    return selIds;
  }
  const ids = [];
  for (const item of this.dataset) {
    ids.push(item.gid);
  }
  switch (subset) {
    case 'all':
      return ids;
    case 'unselected':
      return ids.filter(n => !selIds.includes(n));
  }
}
HandleMemoryAction(event: any) {
  const layerId = this.results[this.selectedIndex].layer;
  const layer: SLLayer = this.map.GetLayerById(layerId);
  const memory: SLMapMemory = this.map.memory as SLMapMemory;
  let rows = [];
  const params: any = {};
  switch (event.memoryAction) {
    case 'memory-query':
      params.featureLayer = memory.layer.id;
      params.action = 'info/query-by-feature';
      params.gids = [memory.features];
      this.map.component.HandleToolAction(params);
      break;
    case 'memory-query-vis':
      params.featureLayer = memory.layer.id;
      params.action = 'info/query-by-feature';
      params.gids = [memory.features];
      params.visOnly = true;
      this.map.component.HandleToolAction(params);
      break;
    case 'memory-add-sel':
      memory.MemoryAdd(layer, this.GetGIDs('selected')).catch((reason) => {
        reason = reason;
        const message = 'Memory is currently holding features for a different layer. Would you like to clear memory and add the selected features?';
        this.messager.Confirm(
          message,
          () => {
            memory.Clear();
            memory.MemoryAdd(layer, this.GetGIDs('selected'));
          },
          () => {

          }
        );
      });
      break;
    case 'memory-remove-sel':
      memory.MemoryRemove(layer, this.GetGIDs('selected')).catch((reason) => {
        reason = reason;
        this.messager.Notify('Remembered features are for a different layer', true);
      });
      break;
    case 'memory-add-unsel':
      memory.MemoryAdd(layer, this.GetGIDs('unselected')).catch((reason) => {
        reason = reason;
        const message = 'Memory is currently holding features for a different layer. Would you like to clear memory and add the unselected features?';
        this.messager.Confirm(
          message,
          () => {
            memory.Clear();
            memory.MemoryAdd(layer, this.GetGIDs('unselected'));
          },
          () => {

          }
        );
      });
      break;
    case 'memory-remove-unsel':
      memory.MemoryRemove(layer, this.GetGIDs('unselected')).catch((reason) => {
        reason = reason;
        this.messager.Notify('Remembered features are for a different layer', true);
      });
      break;
    case 'memory-sel':
      rows = [];
      // tslint:disable-next-line:prefer-for-of
      // tslint:disable-next-line: no-shadowed-variable
      for (let i = 0; i < this.dataset.length; i++) {
        if (memory.IsRememberedFeature(this.dataset[i].gid) === true) {
          rows.push(i);
        }
      }
      this.grid1.gridService.setSelectedRows(rows);
      this.isSettingSelections = true;
      this.SelectionsChanged();
      this.isSettingSelections = false;
      break;
    case 'memory-unsel':
      rows = this.grid1.gridService.getSelectedRows();
      const newRows = [];
      this.grid1.gridService.setSelectedRows([]);
      for (const row of rows) {
        const rowGid = this.grid1.gridService.getDataItemByRowIndex(row).gid;
        if (!memory.IsRememberedFeature(rowGid)) {
          newRows.push(newRows);
        }
      }
      this.grid1.gridService.setSelectedRows(newRows);
      this.isSettingSelections = true;
      this.SelectionsChanged();
      this.isSettingSelections = false;
      break;
    case 'memory-clear':
      memory.Clear();
  }
}
HandleZoomToAction(e: any) {
  if (this.selectedIndex < 0) {
    return;
  }
  const layerId = this.results[this.selectedIndex].layer;
  const layer: SLLayer = this.map.GetLayerById(layerId);
  let features: any;
  switch (e.zoomToToolsAction) {
    case 'zoom-to-all':
      features = this.GetGIDs('all');
      break;
    case 'zoom-to-selected':
      features = this.GetGIDs('selected');
      break;
    case 'zoom-to-unsel':
      features = this.GetGIDs('unselected');
      break;
    case 'zoom-to-layer':
      features = null;
      layer.ZoomToFeatures(features);
      return;
  }
  if (!!features) {
    if (features.length > 0) {
      layer.ZoomToFeatures(features);
    }
  }
}
HandleSelectAction(e: any) {
  if (this.map === undefined) { return; }
  if (this.map.component === undefined) {
    return;
  }
  switch (e.selectAction) {
    case 'info':
      this.map.component.ToggleInteraction('info', true);
      break;
    case 'query':
      this.map.component.ToggleInteraction('query', true);
      break;
    case 'navigation':
      this.map.component.ToggleInteraction('navigating', true);
      break;
    case 'select-add':
      this.map.component.ToggleInteraction('singleSelecting', true);
      break;
    case 'unselect':
      this.map.component.ToggleInteraction('singleDeselecting', true);
      break;
    case 'roi-sel':
      this.map.component.ToggleInteraction('roiSelecting', true);
      break;
    case 'roi-unsel':
      this.map.component.ToggleInteraction('roiUnselecting', true);
      break;
    case 'send-to-puc':
      this.pucSyncer.SynchToChannel();
      break;
      /*this.resultsSvc.Synch({
        channel: this.synchProxy.channel,
        data: { moment: this.moment, selections: this.currentSelections },
        source: this.synchProxy.synchId,
        topic: 'synch-data'
      });*/

      // this.map.component.PUCMan.LoadFromResults();
      break;

  }
}
AppendResults(features: Array<any>) {
  const newGids = [];
  const selected = this.GetGIDs('selected');
  this.tabsReady = false;
  this.cdr.markForCheck();
  this.cdr.detectChanges();
  for (const feature of features) {
    if (selected.indexOf(feature.gid) > -1) continue;
    newGids.push(feature.gid);
    selected.push(feature.gid);
    let hasMatch = false;
    for (const resultFeature of this.results[this.selectedIndex].features) {
      if (resultFeature.gid === feature.gid) {
        hasMatch = true;
        break;
      }
    }
    if (hasMatch) { continue; }
    if (feature.hasOwnProperty('id') === false) {
      feature.id = feature.gid;
    }
    //this.results[this.selectedIndex].features.push(feature);
    this.grid1.gridService.addItem(feature, { highlightRow: true });
    /*this.gridObj.invalidateAllRows();
    window.requestAnimationFrame(() => {
      this.gridObj.render();
    })*/

    // this.dataset.push(feature);
    // this.ShowLayer(this.selectedIndex);
  }
  const rows = [];
  // tslint:disable-next-line:prefer-for-of
  // tslint:disable-next-line: no-shadowed-variable
  for (let i = 0; i < this.dataset.length; i++) {

    if (selected.indexOf(this.dataset[i].gid) > -1) {
      rows.push(i);
    }
  }
  this.grid1.gridService.setSelectedRows(rows);
  this.layers[this.selectedIndex].count = this.results[this.selectedIndex].features.length;
  this.tabsReady = true;
  this.cdr.markForCheck();
  this.cdr.detectChanges();
  this.isSettingSelections = true;
  this.SelectionsChanged();
  this.isSettingSelections = false;



}
ExcludeResults(features: Array<any>) {
  this.tabsReady = false;
  this.cdr.markForCheck();
  this.cdr.detectChanges();
  const selected = this.GetGIDs('selected');
  for (const feature of features) {
    if (feature.gid === undefined) continue;
    let selIndex = selected.indexOf(feature.gid);
    while (selIndex > -1) {
      selected.splice(selIndex, 1);
      selIndex = selected.indexOf(feature.gid);
    }
  }
  const rows = this.grid1.gridService.getSelectedRows();

  // tslint:disable-next-line:prefer-for-of
  // tslint:disable-next-line: no-shadowed-variable

  const selRows = [];
  for (const row of rows) {
    if (selected.indexOf(this.grid1.gridService.getDataItemByRowIndex(row).gid) > -1) {
      selRows.push(row);
    }
  }
  this.grid1.gridService.setSelectedRows(selRows);
  this.isSettingSelections = true;
  this.layers[this.selectedIndex].count = this.results[this.selectedIndex].features.length;
  this.tabsReady = true;
  this.SelectionsChanged();
  this.isSettingSelections = false;



}
ClearAll() {
  this.selectTools.Reset();
  if (!!this.map) {
    this.map.ClearResult();
  }
  this.hasResults = false;
  this.resultsSvc.history.synchResultsSet['results-list'] = null;
  this.columnDefinitions = [];
  this.dataset = [];
  this.UpdateGrid();
  /*this.resultsSvc.Synch({
    channel: this.synchProxy.channel,
    data: null,
    topic: 'clear-results',
    source: this.synchProxy.synchId
  })*/
  this.resultsSvc.history.RegisterSelection(this.synchProxy.synchId, null);
}
ResetSelectMode() {
  this.selectTools.Reset();
}
GetResultFeatureInfo(gid: any, layer ?: SLLayer): any {
  let resultSet = this.results[this.selectedIndex];
  if (!!layer) {
    let i = -1;
    for (const result of this.results) {
      i += 1;
      if (result.layer === layer.id) {
        resultSet = this.results[i];
        break;
      }
    }
  } else {
    layer = this.map.GetLayerById(this.results[this.selectedIndex].layer);
  }
  let i2 = -1;
  for (const feature of resultSet.features) {
    i2 += 1;
    if (feature.gid === gid) {
      return { feature: (feature), index: i2, count: resultSet.features.length, layer: (layer) };
    }
  }
  return null;
}
ShowInInfo(layer: SLLayer, gid: any) {
  const unfeatures: Array<string> = [];
  for (const result of this.moment.resultSet.results) {
    if (result.layer === layer.id) {
      for (const feature of result.features) {
        unfeatures.push(feature.gid);
      }
    }
  }
  unfeatures.splice(unfeatures.indexOf(gid), 1);
  const selections: ISelectionInfo = {
    id: UUID.UUID(),
    layer: (layer),
    layerId: layer.id,
    selectionMode: 'single',
    features: [gid],
    unfeatures: (unfeatures)
  }
  const event: SynchSelectionsEvent = {
    channel: this.moment.id,
    data: { moment: this.moment, selections: (selections) },
    source: this.synchProxy.synchId,
    topic: 'synch-data',
    synchTo: 'info',
    synchFrom: this.synchProxy.synchId
  }
  this.resultsSvc.Synch(event);
  /*
  const params: any = {};
  params.layer = layer;
  params.action = 'info/view-attributes';
  params.gid = gid;
  params.view = 'edit';
  this.map.component.HandleToolAction(params);
  */
}
ShowWhenReady() {
  // if (this.gridReady === false) {
  window.requestAnimationFrame(() => {
    this.ShowLayer(this.selectedIndex);
  });
  // }
}
HandleSynchEvent(event: SynchEvent) {
  const hasMoment = !!this.moment;
  const hasData = !!event.data;
  const hasDataMoment = (hasData) ? !!event.data.moment : false;

  if (hasMoment && hasDataMoment === true) {
    const layer = this.GetSLLayer();
    if ((event.source === 'history') && (event.topic === 'moment-change')) {
      switch (event.data.name) {
        case 'moment-pre-change':
          if (
            !(this.moment && (event.data.moment.id === this.moment.id))
            || !(!!layer && !!this.moment.displayStates && !!this.moment.displayStates[layer.id])
          ) {
            const index = this.selectedIndex;
            const rows = this.selectedRows;
            this.grid1.gridService.deleteItems(this.dataset);
            this.dataset = [];
            this.gridObj.invalidate();
            this.grid1.gridService.resetGrid([]);
            this.UpdateGrid();
          }
          return;
          break;
        case 'moment-change':
          if (
            !(this.moment && (event.data.moment.id === this.moment.id))
            || !(!!layer && !!this.moment.displayStates && !!this.moment.displayStates[layer.id])
          ) {
            this.gridObj.invalidateAllRows();
            window.requestAnimationFrame(() => {
              this.gridObj.render();
            })
            // this.UpdateLayer();
          } else {
            this.gridObj.invalidateAllRows();
            window.requestAnimationFrame(() => {
              this.gridObj.render();
            })

            // this.grid1.gridService.renderGrid();
          }
          return;


      }
    }
  }

  let handlerName = 'Handle';
  if (event.source.indexOf(this.synchProxy.synchId) === 0) {
    if (event.topic !== 'request-synch') {
      return;
    }
  }
  this.lastSynchEvent = event;
  const parts = event.topic.split('-');
  for (const part of parts) {
    handlerName += part[0].toUpperCase();
    handlerName += part.substr(1);
  }

  if (typeof this[handlerName] === 'function') {
    this[handlerName](event);
  }
}
HandleSynchStateChange(event: SynchEvent) {
  switch (event.source) {
    case 'result-popup':
    case 'popup-control':
      this.pucSynching = event.data.state;
      break;
    case 'info':
      this.infoSynching = event.data.state;
      break;
  }
  if ((!this.pucSynching) && (!this.infoSynching)) {
    this.selectMode = 'multi';
  } else {
    this.selectMode = 'single';
  }
  this.UpdateMultiSelect();

}
UpdateMultiSelect() {
  $('div[title="Select/Deselect All"] label').toggleClass('hidden', this.selectMode === 'single');
}
HandleSelectionChange(event: SynchSelectionsEvent, forceShow: boolean = false) {
  forceShow = null;
  this.isSettingSelections = true;
  const compareId = (!this.moment) ? null : this.moment.id;
  if ((compareId !== event.data.moment.id)) {
    this.ShowResultMoment(event.data.moment);
  }
  if (!!event.data.selections) {
    this.currentSelections = event.data.selections;
    if (event.synchronizing !== null) {
      this.currentSelections.selectionMode = this.selectMode;//  event.synchronizing ? 'single' : 'multi';
    }
    this.resultsSvc.history.RegisterSelection(this.synchProxy.synchId, this.currentSelections.id);
    this.isSettingSelections = true;
    this.UpdateSelections(this.currentSelections);
    this.isSettingSelections = false;


  }

  this.isSettingSelections = false;
  this.UpdateMultiSelect();
  this.map.SetHasResults();
  this.map.OpenExtended('results');



}
HandleResultStateChange(event: SynchEvent) {
  if (event.source === this.synchProxy.synchId) {
    return;
  }
  if (!!event.data.contextState) {
    const context = event.data.contextState;

    this.ShowResultMoment(event.data.moment, context.layer, context.features);
    this.UpdateSelections(event.data.contextState);
  } else {
    this.ShowResultMoment(event.data);
  }

}
HandleSynchData(event: SynchSelectionsEvent) {
  if (event.synchTo !== this.synchProxy.synchId) {
    if (event.synchFrom !== this.synchProxy.synchId) {
      return;
    }
  }
  /*if (event.channel !== this.synchProxy.channel) {
    return;
  }
  if (event.source === this.synchProxy.synchId) {
    return;
  }
  */
  this.moment = event.data.moment;
  this.resultsSvc.history.RegisterSynch(this.synchProxy.synchId, this.moment.id);


  this.synchProxy.channel = this.moment.id;
  const results = this.moment.resultSet.results;
  this.handlingResultChange = true;

  this.ShowResults(results, event.data?.selections?.layer, event.data?.selections?.features[0], false);
  this.UpdateTabSet();

  this.HandleSelectionChange(event, true);
  this.handlingResultChange = false;

  /* else {
    const selectionsEvent: SynchSelectionsEvent = {
      channel: this.moment.id,
      data: { moment: this.moment, selections: this.selections },
      source: this.synchProxy.synchId,
      topic: 'selection-change'
    }
    this.resultsSvc.Synch(
      selectionsEvent
    );
  }*/
  // this.HandleSetResults(event);
}
HandleRequestSynch(event: SynchEvent) {
  if (event.synchFrom !== this.synchProxy.synchId) {
    return;
  }
  switch (event.synchFrom) {
    case 'result-popup':
    case 'popup-control':
      this.pucSynching = true;
      break;
    case 'info':
      this.infoSynching = true;
      break;
  }
  this.resultsSvc.Synch(
    {
      channel: this.synchProxy.channel,
      data: { moment: this.moment, selections: this.currentSelections },
      source: this.synchProxy.synchId,
      topic: 'synch-data',
      synchFrom: event.synchFrom,
      synchTo: event.synchTo
    }
  )
}
HandleRenderRequest(event: SynchEvent) {
  if (event.synchFrom !== this.synchProxy.synchId) {
    return;
  }
  this.resultsSvc.Synch(
    {
      channel: 'renderer',
      data: { moment: this.moment, selections: this.currentSelections },
      source: this.synchProxy.synchId,
      topic: 'render',
      synchFrom: event.synchFrom,
      synchTo: event.synchTo
    }
  );
}
HandleDisplayedLayersUpdate(event: SynchEvent) {
  if (event.channel === this.synchProxy.channel) {
    if (event.source === 'result-gallery-layers') {
      this.selections = this.moment.resultSet.displayedLayers;
      this.UpdateTabSet();
    }
  }
}
HandleSetResults(event: SynchEvent) {

  switch (event.source) {
    case 'query-by-feature':
    case 'query-layers':
    case 'query':
      if (this.map.src.queryToResults === false) {
        break;
      }
    // tslint:disable-next-line: no-switch-case-fall-through
    case 'roi-query':
      if (this.map.src.roiToResults === false) {
        break;
      }
    // tslint:disable-next-line: no-switch-case-fall-through
    case 'search':

      this.ShowResultMoment(event.data as ResultMoment);
      this.map.ShowResultsView();
      this.map.OpenExtended('results');
      const renderEvent: SynchSelectionsEvent = {
        channel: 'renderer',
        source: this.synchProxy.synchId,
        topic: 'render',
        data: { moment: (this.moment), selections: (this.selections) }
      }
      this.resultsSvc.Synch(renderEvent);


      break;
  }
}
UpdateGroupSummaries(group: any) {
  // const grouping = this.grid1.dataView.getGrouping()[group.level];

  this.grid1.dataView.refresh();

  if (group.groupingKey === '__grandTotal') {
    return;
  }
  if (!this.aggregatorsVDict[group.groupingKey]) {
    this.aggregatorsVDict[group.groupingKey] = new AggregatorSet(true);
    (this.aggregatorsVDict[group.groupingKey]).FromAggColumnInfo(this.aggregatorSet.GetAggColumnInfo());
  }
  const groupAggregator = this.aggregatorsVDict[group.groupingKey];

  if (!this.groupedRowsVDict.hasOwnProperty(group.groupingKey)) {
    this.groupedRowsVDict[group.groupingKey] = true;
  }

  groupAggregator.init();
  for (const row of group.rows) {
    groupAggregator.accumulate(row);
  }
  if (!this.groupValuesVDict[group.groupingKey]) {
    this.groupValuesVDict[group.groupingKey] = { group: (group) };
  }
  groupAggregator.storeResult(this.groupValuesVDict[group.groupingKey], (args) => {
    group.__groupTotals = this.groupValuesVDict[group.groupingKey];

  });

  if (!!group.groups && !!group.groups.length && group.groups.length > 0) {
    for (const subGroup of group.groups) {
      this.UpdateGroupSummaries(subGroup);
    }
  }


}
UpdateSummaries() {

  const groups = this.grid1.dataView.getGroups() as Array<any>;
  for (const group of groups) {
    this.UpdateGroupSummaries(group);

  }
  // let total = 0;
  // let i = this.dataset.length;
  // const columnElement = grid.getFooterRowColumn(columnId);
  // $(columnElement).html('');
  this.aggregatorSet.init();
  this.groupTotals = {
    group: { rows: this.dataset, getter: '__grandTotal' }
  };
  this.groupValuesVDict.__grandTotal = this.groupTotals
  this.aggregatorSet.init();
  for (const row of this.dataset) {
    this.aggregatorSet.accumulate(row);
  }
  this.aggregatorSet.storeResult(this.groupValuesVDict.__grandTotal, () => {
    this.grid1.slickGrid.invalidate();
    this.grid1.dataView.refresh();
  });

  /*const dataIterator = new NonBlockingIterator(this.dataset, (result) => {
    this.aggregatorSet.storeResult(this.groupTotals, () => {
      this.grid1.slickGrid.invalidate();
    })
  }).ForEach((entry) => {
    this.aggregatorSet.accumulate(entry.item);
  });
  */
  this.messager.CancelProgress('Updating table data');
}
UpdateAggHeight(maxAggs) {
  const height = this.ComputeHeight(this.height);
  const aggCount = maxAggs - 1;
  const newHeight = `calc(${height} - (${aggCount} * 32px) - 6.5em)`;
  $('.slick-viewport').css('max-height', newHeight);
  $('.slick-footerrow-columns').css('height', `calc(${maxAggs} * 32px)`);
  this.gridOptions.rowHeight = maxAggs * (1.8 * 16);
  this.gridObj.invalidate();
}
ToggleAggregator(column: Column<any>, aggName: AggName) {
  let isOn = false;
  this.aggregatorSet.ToggleAggColumn(aggName, column);
  /* for (const group of this.grid1.dataView.getGrouping()) {
    if (!group.aggregators) {
      group.aggregators = [new AggregatorSet()];
    }
    group.aggregators[0] = new AggregatorSet();
    group.aggregators[0].FromAggColumnInfo(this.aggregatorSet.GetAggColumnInfo());
  } */

  isOn = this.aggregatorSet.HasAggColumn(aggName, column);
  let agg: any;
  for (const groupingKey in this.aggregatorsVDict) {
    if (this.aggregatorsVDict.hasOwnProperty(groupingKey)) {
      if (groupingKey === '__grandTotal') {
        continue;
      }
      agg = this.aggregatorsVDict[groupingKey];
      agg.ToggleAggColumn(aggName, column, isOn);
    }
  }
  // this.gridObj.invalidate();


  this.UpdateSummaries();
  this.grid1.dataView.setGrouping(this.grid1.dataView.getGrouping());
  // this.grid1.dataView.refresh();
  this.UpdateColumnHeaders();
  this.UpdateDisplayState();
  return isOn;

}
GroupsHaveAgg(aggIndex: number, excludeColumn: boolean) {
  // const activeGroups: any[] = this.grid1.dataView.getGrouping();
  let count = 0;
  for (const column of this.columnDefinitions) {
    if (!column.params.aggregators) {
      continue;
    }
    if (column.params.aggregators[aggIndex] instanceof NoneAggregator) {
      continue;
    }
    count += 1;
  }
  return count > 0;
}
GetColumnByName(name, columns ?: Array<Decorable>): any {
  const set = (!!columns) ? columns : this.columnDefinitions;
  for (const columnDef of set) {
    if (columnDef?.id === name) {
      return columnDef;
    }
  }
  return false;
}
UpdateColumnHeaders() {
  for (const column of this.grid1.slickGrid.getColumns()) {
    const colHeaderElement = $('.sl-col-' + column.id);
    if (!!colHeaderElement) {
      $('.slick-header-menubutton', colHeaderElement).toggleClass(
        'summarized', this.aggregatorSet.ColumnHasAggs(column)
      );
    }
  }
}
GetColumnIndex(columnId: any): number {
  let i = -1;
  for (const column of this.gridObj.getColumns()) {
    i += 1;
    if ('' + column.id === '' + columnId) {
      return i;
    }
  }
  return i;
}
GetColumnStartOffset() {
  if (this.anchorColumn === '') {
    return 2;
  }
  return this.GetColumnIndex(this.anchorColumn) + 1;
}
AnchorToFront(columnId: any) {
  this.MoveColumnToFront(columnId);
  this.anchorColumn = columnId;

  const columnOffset = this.GetColumnIndex(this.anchorColumn);
  this.gridObj.setOptions({ frozenColumn: columnOffset }, true, true);
  if (ColumnFilter.currentInstance) {
    ColumnFilter.currentInstance.Update();
  }




}
RemoveFromAnchored(columnId: any) {
  // get anchor column
  const anchorColumn = this.anchorColumn;
  this.anchorColumn = '';
  // const start = this.GetColumnStartOffset();
  // remove anchoring
  this.gridObj.setOptions({ frozenColumn: -1 });
  // loop through columns up to anchor column
  for (const id of this.GetCurrentColumnIds()) {
    // if column is not column id anchor to front

    if (id === columnId) {
      if (id === anchorColumn) {
        // just in case the anchor column is being removed from anchored
        break;
      } else {
        continue;
      }
    }
    this.AnchorToFront(id);

    if (id === anchorColumn) {
      break;
    }


  }

  // move target column to front.
  this.MoveColumnToFront(columnId);
  // re-apply filter
  if (ColumnFilter.currentInstance) {
    ColumnFilter.currentInstance.Update();
  }
  // update display state
  this.UpdateDisplayState();
}
MoveColumnToFront(columnId: any) {
  const i = this.GetColumnIndex(columnId);
  const startI = this.GetColumnStartOffset();
  const columns = this.gridObj.getColumns();
  const column = columns[i];
  if (i > startI) {
    columns.splice(i, 1);
    columns.splice(startI, 0, column);
  } else {
    columns.splice(startI, 0, column);
    columns.splice(i, 1);
  }
  this.gridObj.setColumns(columns);
  ColumnFilter.MoveToFront(columnId, startI);

  this.HandleColumnReorder();

}
AnchorAtColumn(columnId: any) {
  // const start = 2;

  const filter = ColumnFilter.currentInstance.filterVal;

  const columns = this.gridObj.getColumns();
  this.anchorColumn = '';
  this.gridObj.setOptions({ frozenColumn: -1 }, true, true);
  let i = -1;
  const targetColumns = []
  for (const column of columns) {
    i += 1;
    if (i < 2) {
      continue;
    }
    targetColumns.push(column);
    if (column.id === columnId) {
      break;
    }
  }
  ColumnFilter.currentInstance.Filter('');
  for (const column of targetColumns) {
    this.AnchorToFront(column.id);
  }
  // this.anchorColumn = columnId;
  // this.gridObj.setOptions({frozenColumnId:columnId});
  ColumnFilter.currentInstance.Filter('' + filter);
  /* for (let i = start; i <= columnOffset; i++) {
    this.AnchorToFront(columns[i].id);
  }*/


  this.UpdateDisplayState();
  // args.grid.setOptions({ frozenColumn: this.GetColumnIndex(this.anchorColumn) });
  // args.grid.resizeCanvas();
}

FitColumnWidth(column: Column<any>): number {

  return ColumnFormatter.FitWidth(this.dataset, this.aggregatorSet, column);

}
HandleColumnReorder() {
  if (this.anchorColumn !== '') {
    const frozenColumn = this.gridObj.getOptions().frozenColumn;
    if (frozenColumn !== -1) {
      this.anchorColumn = this.gridObj.getColumns()[this.gridObj.getOptions().frozenColumn].id;
    }
  }
  this.UpdateColumnHeaders();
  this.UpdateSummaries();
  if (ColumnFilter.currentInstance) {
    ColumnFilter.currentInstance.Update();
  }
  this.UpdateDisplayState();

}
GetCurrentColumnIds(): Array < string > {
  const columns = (!!ColumnFilter.columns) ? ColumnFilter.GetColumns() : this.gridObj.getColumns();

  const ids = [];
  for(const column of columns) {
    if (!column) {
      // Debug Test: console.log(columns);
    } else {
      ids.push('' + column.id);
    }
  }
    return ids;
}

RestoreDisplayState() {
  this.restoring = true;
  const layerId = this.results[this.selectedIndex].layer;
  const displayState: ResultDisplayState = this.moment.displayStates[layerId];
  this.anchorColumn = '';
  if (displayState.columnIds) {
    const columnIds = displayState.columnIds
    const columns = this.gridObj.getColumns();
    const newOrder = [];
    for (const colName of columnIds) {
      newOrder.push(this.GetColumnByName(colName, columns));
    }
    this.gridObj.setColumns(newOrder);
    ColumnFilter.SetColumns(newOrder);
    // this.gridObj.setColumns(newOrder);
  } else {
    ColumnFilter.SetColumns(this.gridObj.getColumns());
  }
  if (displayState.anchorColumn) {
    this.anchorColumn = displayState.anchorColumn;
    this.AnchorAtColumn(this.anchorColumn);
  }
  if (!!displayState.columnFilters) {
    const filters = [];
    for (const filter of displayState.columnFilters) {
      const column = this.GetColumnByName(filter.columnId);
      const filterInfo: any = JSON.parse(JSON.stringify(filter));
      filterInfo.columnDef = column;
      filters.push(filterInfo);
    }
    this.grid1.filterService.updateFilters(filters, false, true, false);
  }
  if (!!displayState.sorting) {
    this.gridObj.setSortColumns(displayState.sorting);
  }
  if (displayState.aggregators) {
    this.aggregatorSet.FromAggColumnIds(this.gridObj.getColumns(), displayState.aggregators);
  }
  $('.slick-placeholder', $('.grouping-row')).toggleClass('hidden', false);
  $('.slick-placeholder', $('.grouping-row')).attr('style', '');

  if (displayState.groupingIds) {
    if (this.draggableGroupingPlugin && this.draggableGroupingPlugin.setDroppedGroups) {
      this.draggableGroupingPlugin.setDroppedGroups(displayState.groupingIds);
    }
  }
  this.gridObj.setHeaderRowVisibility(displayState.showFilters);
  this.gridObj.setOptions({ showHeaderRow: (!!displayState.showFilters) });
  this.ToggleGroupingRow(displayState.showGroupings);

  this.UpdateSummaries();
  this.UpdateColumnHeaders();
  if (displayState.filter) {
    if (ColumnFilter.currentInstance && ColumnFilter.currentInstance.Filter) {
      ColumnFilter.currentInstance.Filter(displayState.filter);
    }
  }

  this.restoring = false;
}
UpdateDisplayState() {
  if (this.restoring === true) {
    return;
  }

  const layerId = this.results[this.selectedIndex].layer;
  let displayState: ResultDisplayState = this.moment.displayStates[layerId];

  let filter = '';
  if (this.filterInfo && this.filterInfo.filter) {
    if (this.filterInfo.filter.filtering === true) {
      filter = this.filterInfo.filter.filterVal;
    }
  }
  const groupingInfo = this.grid1.dataView.getGrouping();
  const groupingIds: Array<string> = [];
  if (groupingInfo) {
    for (const grouping of groupingInfo) {
      groupingIds.push('' + grouping.getter);
    }
  }
  const aggColIds: AggColumnIds = this.aggregatorSet.GetAggColumnIds();
  const columnFilters = this.grid1.filterService.getColumnFilters();
  const colFilterInfo = [];
  for (const columnId in columnFilters) {
    if (columnFilters.hasOwnProperty(columnId)) {
      const columnFilter = columnFilters[columnId];
      colFilterInfo.push({ columnId: columnFilter.columnId, operator: columnFilter.operator, searchTerms: columnFilter.searchTerms });
    }
  }
  // this.gridObj.setOptions({showHeaderRow:$(this.gridObj.getHeaderRow()).is(':visible')});
  displayState = {
    columnIds: this.GetCurrentColumnIds(),
    frozenColumnId: this.gridObj.getOptions().frozenColumn,
    anchorColumn: this.anchorColumn,
    groupingIds: (groupingIds),
    aggregators: aggColIds,
    filter: (filter),
    showFilters: $(this.gridObj.getHeaderRow()).is(':visible'),
    showGroupings: this.gridOptions.draggableGrouping.dropbox.visible,
    sorting: this.gridObj.getSortColumns(),
    columnFilters: colFilterInfo

  }
  this.moment.displayStates[layerId] = displayState;
}
ToggleGroupingRow(isVis ?: boolean) {
  let vis = !isVis;
  if (isVis === undefined) {
    vis = this.gridOptions.draggableGrouping.dropbox.visible;
  }
  this.gridOptions.draggableGrouping.dropbox.visible = !vis;

  $(this.gridOptions.draggableGrouping.dropbox.selector).toggleClass('hidden', !this.gridOptions.draggableGrouping.dropbox.visible);
  this.UpdateDisplayState();
  const noGroupings = this.grid1.dataView.getGrouping().length === 0;
  if (!!noGroupings) {
    $('.slick-placeholder', $('.grouping-row')).toggleClass('hidden', false);
    $('.slick-placeholder', $('.grouping-row')).attr('style', '');
  }
  $('.grouping-row')[0]?.parentElement.classList.toggle('grouping-vis', this.gridOptions.draggableGrouping.dropbox.visible);
  this.UpdateHeight(this.height);

}
LatLonFormatChanged() {
  if (this.grid1 && this.grid1.slickGrid) {
    this.grid1.slickGrid.invalidate();
    this.grid1.dataView.refresh();
  }
}
GetSLLayer(_isMemoryLayer = false): SLLayer {
  return this.GetSLLayerBySelIndex(this.selectedIndex);
}
GetSLLayerBySelIndex(selIndex: number): SLLayer {
  if (!!this.results && this.results.length > 0 && !!this.results[selIndex].layer) {
    return this.map.GetLayerById(this.results[selIndex].layer);
  }
  return null;
}
GetMap(): ISLMap {
  return this.map;
}
GetExportData(typeOption: ExportTypeOption, contentType: ExportContentOption, optData ?: Array<any>) {
  const isLocalExport = ['csv', 'xls'].indexOf(typeOption) > -1;
  let data: any = null;
  if (!!optData) {
    data = optData;
  } else {
    if (
      (typeOption === 'xls' && (this.HasGroupings() || this.HasSummaries())) ||
      (this.aggregators.length > 0) ||
      (this.grid1.dataView.getGrouping().length > 0) ||
      (this.rawMode === true)
    ) {
      return this.GetRows();
    }
    switch (contentType) {
      case 'res-sel':
        data = this.GetRecords('selected');
        break;
      case 'res-unsel':
        data = this.GetRecords('unselected');
        break;
      case 'mem':
        break;
      case 'all':

        if (isLocalExport === false) {
          data = '*';
        } else {
          data = this.GetRecords('all');
        }
        break;
      case 'res-all':
      default:
        data = this.GetRecords('all');
        break;

    }
  }
  if (isLocalExport === false) {
    if (contentType === 'all') {
      return '*';
    } else {
      const gids = [];
      for (const item of data) {
        if (typeof item === 'string') {
          gids.push(item);
        } else {
          if (!!item.gid) {
            gids.push(item.gid);
          }
        }
      }
      return gids;
    }
  }
  return data;

}
GetMetaProvider(): SimpleFunction {
  return this.gridOptions.dataView.customItemMetadataProvider;
}
CanExport() {
  if (this.hasResults === false) {
    return false;
  }
  return (this.GetSLLayer().reporting_level >= ReportingLevels.EXPORT);
}
GetTypeOptions() {
  const options: Decorable = {};
  if (this.GetSLLayer().reporting_level >= ReportingLevels.EXPORT) {
    options.csv = 'Comma Separated Values';
    options.xls = 'Excel (.xls)';
  }
  if (this.GetSLLayer().reporting_level === ReportingLevels.GEOEXPORT) {
    options.shp = 'ESRI Shape File (.zip)';
    options.kmz = 'Google Earth (.kmz)';
  }
  if(this.GetSLLayer().hasGallery) {
    options.gallery = 'Media Gallery (.zip)';
  }
  return options as ExportTypeOptionsDict
}
GetContentOptions(type: ExportTypeOption) {
  if (type === 'xls') {
    if ((this.HasGroupings() || this.HasSummaries())) {
      return [];
    }
  }
  return {
    'res-all': 'All Results',
    'res-sel': 'Selected Results',
    'res-unsel': 'Unselected Results',
  } as ExportContentOptionsDict
}
GetColumnExportOptions() {
  const frozenColumn = this.gridObj.getOptions().frozenColumn;
  const options: Decorable = {
    visible: 'Currently Displayed Columns',
    all: 'All Columns'
  }
  if (frozenColumn === -1) {
    return options;
  }
  options.anchored = 'Anchored Columns';
  options.unanchored = 'Unanchored Columns';
  return options as ExportableColumnOptionDict;
}
GetRawMode(): boolean {
  return this.rawMode;
}
HasGroupings(): boolean {
  return this.grid1.dataView.getGrouping().length > 0;
}
HasGroup(columnId) {
  const groupings = this.grid1.dataView.getGrouping();
  for (const group of groupings) {
    if (group.getter === columnId) return true;
  }
  return false;
}
HasSummaries(): boolean {
  if (!!this.groupTotals && !!this.groupTotals.group && this.groupTotals.group.rows && (this.groupTotals.group.rows.length > 0)) {
    return true;
  }
  return this.aggregators.length > 0;
}
GetExportableColumns(cols: ExportableColumnOption) {
  // const exportable = [];
  switch (cols) {
    case 'all':
      {
        const exportableCols = this.GetSLLayer().GetExportableAttributes(false);
        const outCols = [];
        const currentIds = this.GetCurrentColumnIds();
        for (const id of currentIds) {
          if (exportableCols.indexOf(id) > -1) {
            outCols.push(id);
          }
        }
        return outCols;
      }
      break;
    case 'visible':
      {
        const exportableCols = this.GetSLLayer().GetExportableAttributes(true);
        const outCols = [];
        const currentIds = this.GetCurrentColumnIds();
        for (const id of currentIds) {
          if (exportableCols.indexOf(id) > -1) {
            outCols.push(id);
          }
        }
        return outCols;
      }
      break;
    case 'anchored':
    case 'unanchored':
      {
        const exportableCols = this.GetSLLayer().GetExportableAttributes(true);
        const outCols = [];
        const currentIds = this.GetCurrentColumnIds();
        for (const id of currentIds) {
          if (exportableCols.indexOf(id) > -1) {
            const frozenColumn = this.gridObj.getOptions().frozenColumn;
            const index = this.GetColumnIndex(id);
            if (frozenColumn !== -1) {
              if (cols === 'anchored') {
                if (index > frozenColumn) { continue; }
              } else {
                if (index <= frozenColumn) { continue; }
              }
            }
            outCols.push(id);
          }
        }
        return outCols;
      }
    // break;
    default:
      return [];
    // won't get here

  }

}
UpdateCSS() {
  window.requestAnimationFrame(() => {
    const navTabsQuery = this.domNode.nativeElement.getElementsByClassName('nav-tabs')
    if (navTabsQuery.length === 0) return;
    const navTabs: HTMLDivElement = navTabsQuery[0] as HTMLDivElement;
    navTabs.parentElement.parentElement.classList.toggle('tabs-scrolling', navTabs.clientWidth < navTabs.scrollWidth);
  });
}
UpdateResultMetaStats() {

  const featureCount = this.results[this.selectedIndex]?.features?.length;
  this.hasUnselResults = (!!featureCount) ? (featureCount - this.selectedRows.length) > 0 : false;
  this.hasSelResults = this.selectedRows.length > 0;
  this.hasResults = !!featureCount;
  this.hasUnselResultsChange.emit(this.hasUnselResults);
  this.hasSelResultsChange.emit(this.hasSelResults);
  this.hasResultsChange.emit(this.hasResults);

}
GetSynchChannel(): string | number {
  return this.synchProxy.channel;
}
ReshowLayer(layer ?: SLLayer, record ?: any) {
  if (!!record && !!this.moment && !!record.gid) {
    let matched = false;
    for (const result of this.moment.resultSet.results) {
      if (result.layer === layer.id) {
        let index = -1;
        for (const feature of result.features) {
          index += 1;
          if (feature.gid === record.gid) {
            result.features[index] = record;
            matched = true;
          }
          if (matched) break;
        }
        if (matched) break;
      }
    }
  }
  if (layer.id === this.layers[this.selectedIndex]?.value) {
    this.ShowLayer(this.selectedIndex);
  }
}
}
